// src/locales/tr/auth.ts
var auth = {
  login: {
    title: "Tekrar ho\u015F geldiniz",
    subtitle: "Ayr\u0131cal\u0131klar\u0131n\u0131za eri\u015Fmek i\xE7in giri\u015F yap\u0131n.",
    email: "E-posta",
    password: "\u015Eifre",
    submit: "Giri\u015F yap",
    forgot: "\u015Eifremi unuttum",
    noAccount: "Hesab\u0131n\u0131z yok mu?",
    register: "\xDCye olun"
  },
  register: {
    title: "Ayr\u0131cal\u0131kl\u0131 d\xFCnyaya kat\u0131l\u0131n",
    subtitle: "Rezervasyonlar\u0131n\u0131z\u0131, tekliflerinizi ve faturalar\u0131n\u0131z\u0131 tek yerden y\xF6netin.",
    firstName: "Ad",
    lastName: "Soyad",
    phone: "Telefon (iste\u011Fe ba\u011Fl\u0131)",
    phoneHint: "\xDClke kodunu se\xE7ip numaran\u0131z\u0131 yaz\u0131n.",
    passwordHint: "En az 10 karakter; harf ve rakam i\xE7ermeli.",
    acceptTerms: "<terms>\xDCyelik s\xF6zle\u015Fmesini</terms> ve <kvkk>KVKK ayd\u0131nlatma metnini</kvkk> okudum, kabul ediyorum.",
    marketingOptIn: "Kampanya ve ayr\u0131cal\u0131klardan e-posta ile haberdar olmak istiyorum.",
    submit: "Hesap olu\u015Ftur",
    hasAccount: "Zaten \xFCye misiniz?",
    login: "Giri\u015F yap\u0131n",
    success: "Hesab\u0131n\u0131z olu\u015Fturuldu. Do\u011Frulama ba\u011Flant\u0131s\u0131n\u0131 e-posta adresinize g\xF6nderdik."
  },
  forgot: {
    title: "\u015Eifrenizi mi unuttunuz?",
    subtitle: "E-posta adresinizi girin; size bir s\u0131f\u0131rlama ba\u011Flant\u0131s\u0131 g\xF6nderelim.",
    submit: "Ba\u011Flant\u0131 g\xF6nder",
    sent: "Bu adrese kay\u0131tl\u0131 bir hesap varsa s\u0131f\u0131rlama ba\u011Flant\u0131s\u0131 g\xF6nderildi.",
    backToLogin: "Giri\u015Fe d\xF6n"
  },
  reset: {
    title: "Yeni \u015Fifre belirleyin",
    password: "Yeni \u015Fifre",
    submit: "\u015Eifreyi g\xFCncelle",
    success: "\u015Eifreniz g\xFCncellendi. Yeni \u015Fifrenizle giri\u015F yapabilirsiniz.",
    missingToken: "Ba\u011Flant\u0131 ge\xE7ersiz veya s\xFCresi dolmu\u015F."
  },
  verify: {
    title: "E-posta do\u011Frulama",
    verifying: "E-posta adresiniz do\u011Frulan\u0131yor\u2026",
    success: "E-posta adresiniz do\u011Fruland\u0131. Te\u015Fekk\xFCr ederiz.",
    failed: "Do\u011Frulama ba\u011Flant\u0131s\u0131 ge\xE7ersiz veya s\xFCresi dolmu\u015F."
  },
  admin: {
    title: "Y\xF6netim Paneli",
    subtitle: "Yaln\u0131zca yetkili DuvaMarine personeli i\xE7indir.",
    twoFactor: {
      setupTitle: "\u0130ki ad\u0131ml\u0131 do\u011Frulamay\u0131 etkinle\u015Ftirin",
      setupSubtitle: "Y\xF6netim paneli i\xE7in iki ad\u0131ml\u0131 do\u011Frulama zorunludur. QR kodu Google Authenticator, 1Password veya Authy ile okutun.",
      manualEntry: "QR kodu okutam\u0131yor musunuz? Bu anahtar\u0131 elle girin:",
      enterCode: "Uygulamadaki 6 haneli kod",
      enable: "Do\u011Frula ve etkinle\u015Ftir",
      verifyTitle: "Do\u011Frulama kodu",
      verifySubtitle: "Kimlik do\u011Frulama uygulaman\u0131zdaki 6 haneli kodu girin.",
      verify: "Do\u011Frula",
      useRecovery: "Kurtarma kodu kullan",
      useTotp: "Do\u011Frulama kodu kullan",
      recoveryCode: "Kurtarma kodu",
      recoveryTitle: "Kurtarma kodlar\u0131n\u0131z",
      recoveryHint: "Bu kodlar\u0131 g\xFCvenli bir yerde saklay\u0131n. Telefonunuza eri\u015Femezseniz her kod bir kez kullan\u0131labilir. Kodlar bir daha g\xF6sterilmeyecek.",
      recoveryConfirm: "Kodlar\u0131 saklad\u0131m, devam et",
      expired: "Do\u011Frulama oturumunun s\xFCresi doldu, l\xFCtfen tekrar giri\u015F yap\u0131n."
    }
  }
};

// src/locales/tr/common.ts
var common = {
  phone: { country: "\xDClke kodu" },
  brand: {
    name: "DuvaMarine",
    tagline: "Denizde, g\xF6ky\xFCz\xFCnde ve yolda sessiz l\xFCks"
  },
  actions: {
    save: "Kaydet",
    cancel: "Vazge\xE7",
    continue: "Devam et",
    back: "Geri",
    close: "Kapat",
    submit: "G\xF6nder",
    login: "Giri\u015F yap",
    logout: "\xC7\u0131k\u0131\u015F yap",
    register: "\xDCye ol",
    search: "Ara",
    copy: "Kopyala",
    copied: "Kopyaland\u0131",
    retry: "Tekrar dene",
    download: "\u0130ndir",
    apply: "Uygula",
    clear: "Temizle",
    edit: "D\xFCzenle",
    create: "Olu\u015Ftur",
    remove: "Kald\u0131r",
    add: "Ekle",
    showAll: "T\xFCm\xFCn\xFC g\xF6ster",
    showLess: "Daha az g\xF6ster",
    upload: "Y\xFCkle",
    openMenu: "Men\xFCy\xFC a\xE7"
  },
  nav: {
    home: "Ana sayfa",
    yachts: "Yatlar",
    jets: "\xD6zel jet",
    cars: "L\xFCks ara\xE7",
    transfers: "VIP transfer",
    ownerServices: "Sahip hizmetleri",
    planTrip: "Seyahat planla",
    about: "Hakk\u0131m\u0131zda",
    contact: "\u0130leti\u015Fim",
    account: "Hesab\u0131m"
  },
  categories: {
    yacht: "Yat",
    jet: "Jet",
    car: "Ara\xE7",
    transfer: "VIP Transfer"
  },
  a11y: {
    skipToContent: "\u0130\xE7eri\u011Fe ge\xE7",
    notifications: "Bildirimler",
    closeNotification: "Bildirimi kapat",
    calendarNavigation: "Takvim gezinmesi",
    previousMonth: "\xD6nceki ay",
    nextMonth: "Sonraki ay",
    today: "Bug\xFCn",
    selected: "se\xE7ili"
  },
  language: {
    label: "Dil",
    tr: "T\xFCrk\xE7e",
    en: "English",
    ar: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
    ru: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439"
  },
  theme: {
    label: "Tema",
    dark: "Koyu",
    light: "A\xE7\u0131k"
  },
  states: {
    loading: "Y\xFCkleniyor\u2026",
    empty: "Hen\xFCz kay\u0131t yok",
    error: "Bir \u015Feyler ters gitti",
    network: "Sunucuya ula\u015F\u0131lam\u0131yor. Ba\u011Flant\u0131n\u0131z\u0131 kontrol edin.",
    notFound: "Arad\u0131\u011F\u0131n\u0131z sayfa bulunamad\u0131",
    forbidden: "Bu sayfaya eri\u015Fim yetkiniz yok"
  },
  footer: {
    rights: "\xA9 {{year}} DuvaMarine. T\xFCm haklar\u0131 sakl\u0131d\u0131r.",
    kvkk: "KVKK Ayd\u0131nlatma Metni",
    privacy: "Gizlilik Politikas\u0131",
    cookies: "\xC7erez Politikas\u0131",
    menu: "Alt men\xFC",
    cookieSettings: "\xC7erez tercihleri"
  },
  currency: {
    label: "Para birimi",
    TRY: "T\xFCrk liras\u0131",
    EUR: "Euro",
    USD: "ABD dolar\u0131",
    GBP: "\u0130ngiliz sterlini"
  },
  units: {
    per: { HOUR: "saat", DAY: "g\xFCn", NIGHT: "gece", WEEK: "hafta", MONTH: "ay", SESSION: "seans" },
    short: { HOUR: "sa", DAY: "g\xFCn", NIGHT: "gece", WEEK: "hf", MONTH: "ay", SESSION: "seans" },
    name: {
      HOUR: "Saatlik",
      DAY: "G\xFCnl\xFCk",
      NIGHT: "Gecelik",
      WEEK: "Haftal\u0131k",
      MONTH: "Ayl\u0131k",
      SESSION: "Seansl\u0131k"
    }
  },
  locationTypes: {
    MARINA: "Marina",
    AIRPORT: "Havaliman\u0131",
    CITY: "\u015Eehir",
    DISTRICT: "B\xF6lge",
    OFFICE: "Ofis",
    HOTEL: "Otel",
    PORT: "Liman",
    POINT_OF_INTEREST: "\xD6nemli nokta"
  },
  boolean: { yes: "Var", no: "Yok" },
  pagination: {
    summary: "Sayfa {{page}} / {{total}}",
    previous: "\xD6nceki sayfa",
    next: "Sonraki sayfa"
  },
  carousel: { previous: "\xD6nceki g\xF6rsel", next: "Sonraki g\xF6rsel" },
  counter: { increase: "Art\u0131r", decrease: "Azalt" },
  bookingStatus: {
    DRAFT: "Taslak",
    PENDING_PAYMENT: "\xD6deme bekleniyor",
    AWAITING_CONFIRMATION: "Onay bekleniyor",
    CONFIRMED: "Onayland\u0131",
    IN_PROGRESS: "Devam ediyor",
    COMPLETED: "Tamamland\u0131",
    CANCELLED: "\u0130ptal edildi",
    REFUNDED: "\u0130ade edildi",
    NO_SHOW: "Gelinmedi"
  },
  paymentStatus: {
    PENDING: "Ba\u015Flat\u0131ld\u0131",
    REQUIRES_ACTION: "Do\u011Frulama bekleniyor",
    AUTHORIZED: "\xD6n provizyon",
    SUCCEEDED: "Ba\u015Far\u0131l\u0131",
    FAILED: "Ba\u015Far\u0131s\u0131z",
    CANCELLED: "\u0130ptal",
    REFUNDED: "\u0130ade edildi",
    PARTIALLY_REFUNDED: "K\u0131smi iade"
  },
  paymentKind: {
    DEPOSIT: "Kapora",
    BALANCE: "Bakiye",
    FULL: "Tam \xF6deme",
    QUOTE: "Teklif \xF6demesi",
    OTHER: "Di\u011Fer"
  },
  price: {
    lines: {
      BASE: "Baz \xFCcret",
      SEASON: "Sezon fark\u0131",
      WEEKEND: "Hafta sonu fark\u0131",
      SPECIAL_DAY: "\xD6zel g\xFCn fark\u0131",
      TIME_OF_DAY: "Saat dilimi fark\u0131",
      DURATION_DISCOUNT: "Uzun s\xFCre indirimi",
      EXTRA_GUEST: "Ek misafir"
    },
    legs: "Transfer \xFCcreti \xD7 {{count}}",
    rooms: "{{count}} oda",
    extras: "Ekstralar",
    included: "Dahil",
    subtotal: "Ara toplam",
    discount: "Kupon ({{code}})",
    manualDiscount: "\xD6zel indirim",
    vat: "KDV %{{rate}}",
    total: "Toplam",
    deposit: "Kapora (%{{percent}})",
    balance: "Kalan bakiye",
    paid: "\xD6denen",
    dueNow: "\u015Eimdi \xF6denecek",
    vatExcluded: "Liste fiyatlar\u0131na KDV dahil de\u011Fildir."
  },
  serviceStatus: {
    NEW: "Yeni",
    REVIEWING: "\u0130nceleniyor",
    QUOTE_SENT: "Teklif g\xF6nderildi",
    QUOTE_ACCEPTED: "Teklif onayland\u0131",
    QUOTE_REJECTED: "Teklif reddedildi",
    SCHEDULED: "Planland\u0131",
    IN_PROGRESS: "Devam ediyor",
    COMPLETED: "Tamamland\u0131",
    INVOICED: "Faturaland\u0131",
    CANCELLED: "\u0130ptal edildi"
  },
  quoteStatus: {
    DRAFT: "Taslak",
    SENT: "G\xF6nderildi",
    VIEWED: "G\xF6r\xFCnt\xFClendi",
    ACCEPTED: "Onayland\u0131",
    REJECTED: "Reddedildi",
    EXPIRED: "S\xFCresi doldu",
    CANCELLED: "Geri \xE7ekildi",
    SUPERSEDED: "Yenilendi"
  },
  quoteKind: {
    SERVICE: "Hizmet teklifi",
    CHARTER: "Charter teklifi"
  },
  workOrderStatus: {
    PLANNED: "Planlanacak",
    SCHEDULED: "Planland\u0131",
    IN_PROGRESS: "Devam ediyor",
    ON_HOLD: "Beklemede",
    COMPLETED: "Tamamland\u0131",
    CANCELLED: "\u0130ptal edildi"
  },
  tripPlanStatus: {
    SUBMITTED: "Kapora bekliyor",
    DEPOSIT_PAID: "Kapora al\u0131nd\u0131",
    IN_REVIEW: "\u0130nceleniyor",
    CONFIRMED: "Onayland\u0131",
    COMPLETED: "Tamamland\u0131",
    CANCELLED: "\u0130ptal edildi",
    EXPIRED: "S\xFCresi doldu"
  },
  tripItemRole: {
    JET: "\xD6zel jet",
    TRANSFER: "Transfer",
    STAY: "Konaklama",
    YACHT: "Yat",
    EXPERIENCE: "Deneyim",
    CAR: "Ara\xE7"
  },
  tripItemStatus: {
    PENDING: "Bekliyor",
    RESERVED: "Ayr\u0131ld\u0131",
    UNAVAILABLE: "M\xFCsait de\u011Fil"
  },
  ownedAssetType: {
    YACHT: "Yat",
    JET: "Jet",
    CAR: "Ara\xE7",
    RESIDENCE: "Konut"
  },
  quoteLineType: {
    LABOR: "\u0130\u015F\xE7ilik",
    MATERIAL: "Malzeme",
    SERVICE: "Hizmet",
    FEE: "\xDCcret",
    DISCOUNT: "\u0130ndirim"
  }
};

// src/locales/tr/errors.ts
var errors = {
  INTERNAL_ERROR: "Beklenmeyen bir hata olu\u015Ftu. L\xFCtfen tekrar deneyin.",
  VALIDATION_FAILED: "L\xFCtfen formdaki hatalar\u0131 d\xFCzeltin.",
  NOT_FOUND: "Kay\u0131t bulunamad\u0131.",
  UNAUTHORIZED: "Devam etmek i\xE7in giri\u015F yap\u0131n.",
  FORBIDDEN: "Bu i\u015Flem i\xE7in yetkiniz yok.",
  CONFLICT: "\u0130\u015Flem mevcut bir kay\u0131tla \xE7ak\u0131\u015F\u0131yor.",
  RATE_LIMITED: "\xC7ok fazla istek g\xF6nderdiniz. L\xFCtfen biraz sonra tekrar deneyin.",
  AUTH_INVALID_CREDENTIALS: "E-posta veya \u015Fifre hatal\u0131.",
  AUTH_EMAIL_TAKEN: "Bu e-posta adresiyle kay\u0131tl\u0131 bir hesap zaten var.",
  AUTH_TOKEN_INVALID: "Oturumunuz ge\xE7ersiz. L\xFCtfen tekrar giri\u015F yap\u0131n.",
  AUTH_TOKEN_EXPIRED: "Oturumunuzun s\xFCresi doldu. L\xFCtfen tekrar giri\u015F yap\u0131n.",
  AUTH_SESSION_REVOKED: "Oturumunuz sonland\u0131r\u0131ld\u0131. L\xFCtfen tekrar giri\u015F yap\u0131n.",
  AUTH_REFRESH_REUSED: "G\xFCvenlik nedeniyle oturumlar\u0131n\u0131z kapat\u0131ld\u0131. L\xFCtfen tekrar giri\u015F yap\u0131n.",
  AUTH_TOO_MANY_ATTEMPTS: "\xC7ok fazla ba\u015Far\u0131s\u0131z deneme. L\xFCtfen 15 dakika sonra tekrar deneyin.",
  AUTH_ACCOUNT_SUSPENDED: "Hesab\u0131n\u0131z ask\u0131ya al\u0131nm\u0131\u015F. L\xFCtfen bizimle ileti\u015Fime ge\xE7in.",
  AUTH_WRONG_AREA: "Bu hesapla bu alana giri\u015F yap\u0131lamaz.",
  AUTH_ORIGIN_NOT_ALLOWED: "\u0130stek kayna\u011F\u0131 do\u011Frulanamad\u0131.",
  AUTH_CHALLENGE_INVALID: "Do\u011Frulama oturumunun s\xFCresi doldu. L\xFCtfen tekrar giri\u015F yap\u0131n.",
  AUTH_TWO_FACTOR_INVALID: "Do\u011Frulama kodu hatal\u0131.",
  AUTH_TWO_FACTOR_NOT_SETUP: "\u0130ki ad\u0131ml\u0131 do\u011Frulama hen\xFCz kurulmam\u0131\u015F.",
  AUTH_TWO_FACTOR_ALREADY_ENABLED: "\u0130ki ad\u0131ml\u0131 do\u011Frulama zaten etkin.",
  AUTH_VERIFICATION_TOKEN_INVALID: "Ba\u011Flant\u0131 ge\xE7ersiz veya s\xFCresi dolmu\u015F.",
  ROLE_SYSTEM_IMMUTABLE: "Sistem rol\xFC de\u011Fi\u015Ftirilemez.",
  BOOKING_INVALID_TRANSITION: "Rezervasyon bu duruma ge\xE7irilemez.",
  BOOKING_CONFLICT: "Se\xE7ilen tarihler ba\u015Fka bir rezervasyonla \xE7ak\u0131\u015F\u0131yor.",
  CATEGORY_KEY_TAKEN: "Bu anahtarla bir kategori zaten var.",
  CATEGORY_KEY_IMMUTABLE: "Kategori anahtar\u0131 de\u011Fi\u015Ftirilemez.",
  CATEGORY_LISTING_TYPE_LOCKED: "Bu kategoride ilan varken ilan t\xFCr\xFC (kiral\u0131k/sat\u0131l\u0131k) de\u011Fi\u015Ftirilemez.",
  SLUG_TAKEN: "Bu URL ba\u015Fka bir kay\u0131t taraf\u0131ndan kullan\u0131l\u0131yor.",
  ASSET_CODE_TAKEN: "Bu ilan kodu zaten kullan\u0131l\u0131yor.",
  ASSET_NOT_PUBLISHABLE: "\u0130lan yay\u0131na haz\u0131r de\u011Fil; eksikleri tamamlay\u0131n.",
  ASSET_ATTRIBUTES_INVALID: "\xD6zellikler kategori \u015Femas\u0131na uymuyor.",
  MEDIA_UNSUPPORTED_TYPE: "Desteklenmeyen dosya t\xFCr\xFC. JPEG, PNG, WebP, AVIF, MP4 veya WebM y\xFCkleyin.",
  MEDIA_TOO_LARGE: "Dosya boyutu s\u0131n\u0131r\u0131 a\u015F\u0131yor.",
  MEDIA_REQUIRED: "Bir dosya se\xE7in.",
  AVAILABILITY_BOOKING_OVERLAP: "Bu aral\u0131kta onayl\u0131 bir rezervasyon var; \xF6nce rezervasyonu ta\u015F\u0131y\u0131n.",
  BOOKING_NOT_BOOKABLE: "Se\xE7iminiz bu haliyle rezerve edilemiyor; l\xFCtfen ayr\u0131nt\u0131lar\u0131 kontrol edin.",
  BOOKING_HOLD_EXPIRED: "\xD6deme s\xFCresi doldu ve tarih serbest b\u0131rak\u0131ld\u0131. L\xFCtfen rezervasyonu yeniden ba\u015Flat\u0131n.",
  BOOKING_MANIFEST_REQUIRED: "Her yolcu i\xE7in ad, soyad ve kimlik/pasaport bilgisi gerekli.",
  COUPON_INVALID: "Kupon kodu bu rezervasyonda kullan\u0131lam\u0131yor.",
  COUPON_CODE_TAKEN: "Bu kupon kodu zaten tan\u0131ml\u0131.",
  KEY_TAKEN: "Bu anahtar zaten kullan\u0131l\u0131yor.",
  PAYMENT_NOT_ALLOWED: "Bu rezervasyon i\xE7in \u015Fu anda \xF6deme al\u0131nam\u0131yor.",
  PAYMENT_DECLINED: "\xD6deme onaylanmad\u0131. Kart bilgilerinizi kontrol edip tekrar deneyin.",
  NEWSLETTER_TOKEN_INVALID: "Onay ba\u011Flant\u0131s\u0131 ge\xE7ersiz veya daha \xF6nce kullan\u0131lm\u0131\u015F.",
  PAYMENT_PROVIDER_ERROR: "\xD6deme sa\u011Flay\u0131c\u0131s\u0131na \u015Fu anda ula\u015F\u0131lam\u0131yor. L\xFCtfen biraz sonra tekrar deneyin.",
  REFUND_EXCEEDS_REFUNDABLE: "\u0130ade tutar\u0131 iade edilebilir tutar\u0131 a\u015F\u0131yor.",
  REFUND_ACCOUNT_REQUIRED: "Havale/nakit iadesi i\xE7in \xF6demenin yap\u0131laca\u011F\u0131 hesab\u0131 se\xE7in.",
  REFUND_FAILED: "\u0130ade i\u015Flemi yeniden denenemiyor.",
  CASH_ACCOUNT_INVALID: "Se\xE7ilen kasa/banka hesab\u0131 bu i\u015Flem i\xE7in uygun de\u011Fil (pasif veya para birimi farkl\u0131).",
  LEDGER_NOT_REVERSIBLE: "Bu hareket ters kay\u0131tla d\xFCzeltilemez.",
  EXPENSE_NOT_EDITABLE: "\u0130ptal edilmi\u015F gider d\xFCzenlenemez.",
  INVOICE_NOT_EDITABLE: "Kesilmi\u015F fatura d\xFCzenlenemez; iptal edin veya iade faturas\u0131 olu\u015Fturun.",
  INVOICE_INVALID_STATE: "Fatura bu i\u015Flem i\xE7in uygun durumda de\u011Fil.",
  FX_RATE_MISSING: "Bu tarih i\xE7in d\xF6viz kuru bulunamad\u0131. \xD6nce kur girin.",
  FX_UPDATE_FAILED: "Kurlar TCMB\u2019den al\u0131namad\u0131. Daha sonra tekrar deneyin veya elle girin.",
  RECEIPT_UNSUPPORTED: "Fi\u015F/fatura PDF, JPEG, PNG veya WebP olmal\u0131 (en fazla 10 MB).",
  SERVICE_REQUEST_INVALID_TRANSITION: "Talep bu duruma ge\xE7irilemez.",
  SERVICE_REQUEST_ACTION_REQUIRED: "Bu ad\u0131m bir belgeyle ilerler: teklif g\xF6nderin, i\u015F emrini planlay\u0131n veya fatura kesin.",
  QUOTE_NOT_EDITABLE: "G\xF6nderilmi\u015F teklif d\xFCzenlenemez; yeni bir revizyon olu\u015Fturun.",
  QUOTE_INVALID_STATE: "Teklif bu i\u015Flem i\xE7in uygun durumda de\u011Fil.",
  QUOTE_EXPIRED: "Teklifin ge\xE7erlilik s\xFCresi doldu. Dan\u0131\u015Fman\u0131n\u0131zdan g\xFCncel teklif isteyin.",
  QUOTE_TOTAL_INVALID: "Teklif toplam\u0131 ge\xE7ersiz: indirimler kalem tutarlar\u0131n\u0131 a\u015Famaz.",
  WORK_ORDER_INVALID_TRANSITION: "\u0130\u015F emri bu duruma ge\xE7irilemez.",
  WORK_ORDER_SCHEDULE_REQUIRED: "\xD6nce i\u015F emrinin ba\u015Flang\u0131\xE7 ve biti\u015F zaman\u0131n\u0131 girin.",
  DOCUMENT_UNSUPPORTED: "Belge PDF, JPEG, PNG veya WebP olmal\u0131 (en fazla 10 MB).",
  ROLE_IN_USE: "Bu rolde h\xE2l\xE2 kullan\u0131c\u0131 var. \xD6nce kullan\u0131c\u0131lar\u0131 ba\u015Fka bir role ta\u015F\u0131y\u0131n.",
  ADMIN_SELF_LOCKOUT: "Kendinizi ask\u0131ya alamaz veya kendi s\xFCper admin rol\xFCn\xFCz\xFC kald\u0131ramazs\u0131n\u0131z.",
  ADMIN_USER_INACTIVE: "Bu kullan\u0131c\u0131 ask\u0131ya al\u0131nm\u0131\u015F.",
  MEDIA_IN_USE: "Bu dosya kullan\u0131mda oldu\u011Fu i\xE7in silinemez.",
  BOOKING_RESCHEDULE_NOT_ALLOWED: "Bu rezervasyon ta\u015F\u0131namaz (tamamlanm\u0131\u015F, iptal edilmi\u015F, ba\u015Flam\u0131\u015F ya da birden fazla ilanl\u0131).",
  REVIEW_NOT_ALLOWED: "Yaln\u0131zca hesab\u0131n\u0131zdaki tamamlanm\u0131\u015F rezervasyonlar i\xE7in yorum yaz\u0131labilir.",
  REVIEW_EXISTS: "Bu rezervasyon i\xE7in zaten yorum yazd\u0131n\u0131z.",
  CRM_SENSITIVE_CONSENT_REQUIRED: "Hassas notlar i\xE7in m\xFC\u015Fterinin a\xE7\u0131k r\u0131zas\u0131 (KVKK) gerekir. \xD6nce r\u0131zay\u0131 kaydedin.",
  DATA_REQUEST_OPEN: "Bu t\xFCrde a\xE7\u0131k bir talebiniz zaten var; sonu\xE7lanmas\u0131n\u0131 bekleyin.",
  DATA_DELETION_BLOCKED: "Devam eden rezervasyonlar veya hizmet talepleri oldu\u011Fu i\xE7in hesap \u015Fimdi silinemez.",
  DATA_EXPORT_EXPIRED: "Bu veri dosyas\u0131n\u0131n indirme s\xFCresi doldu; yeni bir talep olu\u015Fturun.",
  TRIP_PLAN_EMPTY: "Plan\u0131n\u0131zda fiyat\u0131 belli en az bir b\xF6l\xFCm olmal\u0131.",
  TRIP_PLAN_NOT_CONFIRMED: "Fatura i\xE7in plan\u0131n onaylanm\u0131\u015F olmas\u0131 gerekir.",
  TRIP_PLAN_INVOICE_EXISTS: "Bu plan i\xE7in zaten bir fatura var.",
  TRIP_PLAN_ITEM_UNAVAILABLE: "Se\xE7ti\u011Finiz ilanlardan biri bu tarihler i\xE7in art\u0131k sunulam\u0131yor; plan\u0131 yeniden olu\u015Fturun.",
  TRIP_PLAN_INVALID_TRANSITION: "Plan bu durumdayken bu i\u015Flem yap\u0131lamaz."
};

// src/locales/tr/validation.ts
var validation = {
  required: "Bu alan zorunludur",
  tooLong: "\xC7ok uzun",
  invalid: "Ge\xE7ersiz de\u011Fer",
  email: "Ge\xE7erli bir e-posta adresi girin",
  phone: "Telefonu uluslararas\u0131 formatta girin (\xF6rn. +905321234567)",
  password: {
    min: "\u015Eifre en az 10 karakter olmal\u0131",
    max: "\u015Eifre en fazla 128 karakter olabilir",
    letter: "\u015Eifre en az bir harf i\xE7ermeli",
    digit: "\u015Eifre en az bir rakam i\xE7ermeli",
    mismatch: "\u015Eifreler e\u015Fle\u015Fmiyor"
  },
  acceptTerms: "Devam etmek i\xE7in s\xF6zle\u015Fmeyi kabul etmelisiniz",
  token: "Ba\u011Flant\u0131 ge\xE7ersiz",
  totp: "6 haneli kodu girin",
  recoveryCode: "Kurtarma kodu XXXXX-XXXXX format\u0131nda olmal\u0131",
  totpOrRecovery: "Do\u011Frulama kodu veya kurtarma kodu girin",
  attributeKey: "Anahtar k\xFC\xE7\xFCk harfle ba\u015Flamal\u0131 ve yaln\u0131zca harf/rakam i\xE7ermeli",
  optionsRequired: "Se\xE7im alanlar\u0131 i\xE7in en az bir se\xE7enek gerekli",
  minGreaterThanMax: "Minimum de\u011Fer maksimumdan b\xFCy\xFCk olamaz",
  duplicateKey: "Bu anahtar zaten kullan\u0131l\u0131yor",
  tripLength: "Seyahat 1 ile 21 gece aras\u0131nda olmal\u0131",
  yachtDays: "Yat g\xFCnleri gece say\u0131s\u0131n\u0131 a\u015Famaz",
  invalidOption: "Ge\xE7ersiz se\xE7enek",
  number: "Say\u0131 girin",
  integer: "Tam say\u0131 girin",
  outOfRange: "De\u011Fer izin verilen aral\u0131\u011F\u0131n d\u0131\u015F\u0131nda",
  date: "Ge\xE7erli bir tarih girin",
  unknownAttribute: "Tan\u0131ms\u0131z \xF6zellik",
  slug: "Yaln\u0131zca k\xFC\xE7\xFCk harf, rakam ve tire kullan\u0131n",
  categoryKey: "K\xFC\xE7\xFCk harfle ba\u015Flamal\u0131; yaln\u0131zca k\xFC\xE7\xFCk harf, rakam ve alt \xE7izgi i\xE7ermeli",
  assetCode: "B\xFCy\xFCk harf, rakam ve tire kullan\u0131n (\xF6rn. YAT-009)",
  dateOrder: "Biti\u015F, ba\u015Flang\u0131\xE7tan sonra olmal\u0131",
  dateWindow: "En fazla 93 g\xFCnl\xFCk aral\u0131k se\xE7ilebilir",
  kvkkRequired: "Devam etmek i\xE7in ayd\u0131nlatma metnini onaylay\u0131n",
  contactRequired: "Telefon veya e-postadan en az birini girin",
  consentRequired: "Abonelik i\xE7in onay gerekli",
  coverRequired: "En az bir foto\u011Fraf y\xFCkleyin",
  money: {
    unsafe: "Tutar desteklenen aral\u0131\u011F\u0131n d\u0131\u015F\u0131nda"
  },
  cancellation: {
    duplicateTier: "Ayn\u0131 s\xFCre i\xE7in birden fazla iade kademesi tan\u0131mlanamaz"
  },
  time: "Ge\xE7erli bir saat se\xE7in",
  couponCode: "Kupon kodu 3\u201340 karakter olmal\u0131; harf, rakam ve tire kullan\u0131n",
  pricing: {
    scope: "Kategori veya ilandan yaln\u0131zca birini se\xE7in",
    seasonValue: "Tutar ya da \xE7arpandan yaln\u0131zca birini girin"
  },
  services: {
    endBeforeStart: "Biti\u015F, ba\u015Flang\u0131\xE7tan \xF6nce olamaz",
    itemsRequired: "En az bir hizmet se\xE7in",
    nationalId: "T.C. kimlik no 11 haneli olmal\u0131",
    language: "Dil kodu iki harf olmal\u0131 (\xF6rn. en)",
    recurrence: "Tekrar kural\u0131 desteklenmiyor"
  },
  finance: {
    sameAccount: "Kaynak ve hedef hesap ayn\u0131 olamaz",
    iban: "Ge\xE7erli bir IBAN girin (\xF6rn. TR12 0006 \u2026)",
    taxNumber: "Vergi no 10, T.C. kimlik no 11 haneli olmal\u0131"
  },
  reviews: {
    commentTooShort: "Yorum en az 10 karakter olmal\u0131"
  },
  settings: {
    titleTemplate: "\u015Eablon sayfa ba\u015Fl\u0131\u011F\u0131 i\xE7in %s i\xE7ermeli",
    ga4: "GA4 kimli\u011Fi G-XXXXXXX bi\xE7iminde olmal\u0131",
    metaPixel: "Pixel kimli\u011Fi yaln\u0131zca rakamlardan olu\u015Fmal\u0131"
  },
  admin: {
    roleRequired: "En az bir rol se\xE7in"
  }
};

// src/locales/tr/web.ts
var web = {
  hero: {
    eyebrow: "\u0130stanbul \xB7 Bodrum \xB7 G\xF6cek \xB7 Fethiye",
    title: "Ufkun \xF6tesinde, yaln\u0131zca size \xF6zel",
    subtitle: "Yat, \xF6zel jet, l\xFCks ara\xE7 ve VIP transfer. Tamam\u0131 kendi filomuz, tamam\u0131 tek bir ayr\u0131cal\u0131kl\u0131 adreste.",
    ownerServices: "Yat, jet veya ara\xE7 sahibi misiniz?",
    ownerServicesCta: "Sahip hizmetlerini ke\u015Ffedin",
    planner: "T\xFCm tatilinizi tek yerden kurgulay\u0131n:",
    plannerCta: "Seyahatinizi planlay\u0131n"
  },
  search: {
    groupsLabel: "Hizmet gruplar\u0131",
    groups: {
      TRAVEL: "Seyahat",
      STAY: "Konaklama",
      EXPERIENCE: "Deneyim",
      ACQUIRE: "Sat\u0131l\u0131k"
    },
    title: "Ne planl\u0131yorsunuz?",
    cta: "M\xFCsaitlik ara",
    ctaQuote: "Teklif se\xE7eneklerini g\xF6r",
    ctaSale: "\u0130lanlar\u0131 g\xF6r",
    nights: "{{count}} gece",
    mobileTrigger: "Nereye, ne zaman?",
    mobileHint: "Konum, tarih ve ki\u015Fi say\u0131s\u0131",
    edit: "Aramay\u0131 d\xFCzenle",
    choose: "Se\xE7in",
    searchLocations: "Marina, havaliman\u0131, otel veya \u015Fehir ara",
    noLocations: "E\u015Fle\u015Fen konum yok",
    everywhereIn: "{{name}} ve \xE7evresi",
    time: "Saat",
    tripType: { ONE_WAY: "Tek y\xF6n", ROUND_TRIP: "Gidi\u015F\u2013d\xF6n\xFC\u015F", MULTI_LEG: "\xC7ok bacakl\u0131" },
    multiLegHint: "Ek bacaklar\u0131 teklif talebinizde belirtebilirsiniz.",
    ownerServices: "Sahip hizmetleri",
    ownerServicesHint: "Bak\u0131m \xB7 \xD6zel \u015Fof\xF6r \xB7 Detailing"
  },
  trust: {
    title: "Neden DuvaMarine",
    fleet: {
      title: "Kendi filomuz",
      body: "Arac\u0131 yok. Her yat, jet ve ara\xE7 DuvaMarine g\xFCvencesiyle i\u015Fletilir."
    },
    concierge: {
      title: "7/24 ki\u015Fisel dan\u0131\u015Fman",
      body: "Rezervasyondan d\xF6n\xFC\u015Fe kadar tek bir muhatap; WhatsApp, telefon veya e-posta ile."
    },
    privacy: {
      title: "Mahremiyet \xF6nceli\u011Fimiz",
      body: "Ki\u015Fisel verileriniz KVKK ve GDPR standartlar\u0131nda korunur."
    }
  },
  home: {
    scroll: "Ke\u015Ffetmek i\xE7in kayd\u0131r\u0131n",
    viewAll: "T\xFCm\xFCn\xFC ke\u015Ffedin",
    priceFrom: "Ba\u015Flayan fiyat",
    emptyLegs: {
      seats: "Koltuk: {{count}}",
      cta: "Teklif al",
      note: "Bo\u015F bacak u\xE7u\u015Flar tek y\xF6nd\xFCr; fiyat u\xE7ak ba\u015F\u0131nad\u0131r."
    },
    readingTime: "{{minutes}} dk okuma",
    followInstagram: "Instagram\u2019da takip edin",
    newsletter: {
      body: "Yeni filo \xFCyeleri, bo\u015F bacak f\u0131rsatlar\u0131 ve sezon ayr\u0131cal\u0131klar\u0131 ayda bir kez e-postan\u0131zda.",
      placeholder: "E-posta adresiniz",
      consent: "Kampanya e-postalar\u0131 almay\u0131 kabul ediyorum; diledi\u011Fim zaman ayr\u0131labilirim.",
      submit: "Abone ol",
      success: "Te\u015Fekk\xFCrler! Aboneli\u011Finizi onaylamak i\xE7in e-postan\u0131za g\xF6nderdi\u011Fimiz ba\u011Flant\u0131ya t\u0131klay\u0131n."
    }
  },
  results: {
    eyebrow: "Arama sonu\xE7lar\u0131",
    count: "Sonu\xE7: {{count}}",
    sort: {
      label: "S\u0131rala",
      RECOMMENDED: "\xD6nerilen",
      PRICE_ASC: "Fiyat: artan",
      PRICE_DESC: "Fiyat: azalan",
      CAPACITY: "Kapasite",
      NEWEST: "Yeni eklenenler",
      RATING: "Puan"
    },
    view: { label: "G\xF6r\xFCn\xFCm", grid: "Izgara", list: "Liste", map: "Harita" },
    filters: {
      title: "Filtreler",
      open: "Filtrele",
      price: "Fiyat aral\u0131\u011F\u0131",
      amenities: "Donan\u0131mlar",
      availableOnly: "Yaln\u0131zca m\xFCsait olanlar",
      clear: "Filtreleri temizle",
      show: "Sonu\xE7lar\u0131 g\xF6ster"
    },
    empty: {
      title: "Kriterlerinize uygun ilan bulunamad\u0131",
      body: "Filtreleri gev\u015Fetmeyi ya da farkl\u0131 bir tarih denemeyi \xF6neririz. Dan\u0131\u015Fmanlar\u0131m\u0131z size \xF6zel se\xE7enekler de sunabilir.",
      cta: "Dan\u0131\u015Fmana sorun"
    },
    needDates: "M\xFCsaitli\u011Fi g\xF6rmek i\xE7in tarih se\xE7in.",
    noRoute: "Bu g\xFCzerg\xE2h i\xE7in \xFCcret, talebiniz \xFCzerine dan\u0131\u015Fmanlar\u0131m\u0131zca belirlenir.",
    unknownLocation: "Se\xE7ilen konum bulunamad\u0131.",
    mapLoading: "Harita y\xFCkleniyor\u2026",
    trip: "{{from}} \u2192 {{to}}",
    charter: {
      title: "Uygun u\xE7ak s\u0131n\u0131flar\u0131",
      subtitle: "Tahmini aral\u0131klar; kesin fiyat charter masam\u0131z\u0131n teklifiyle belirlenir.",
      seats: "{{range}} koltuk",
      aircraft: "U\xE7ak: {{count}}",
      estimate: "Tahmini",
      cta: "Teklif iste",
      trip: "{{distance}} km \xB7 yakla\u015F\u0131k {{duration}} u\xE7u\u015F"
    }
  },
  card: {
    fare: "Transfer \xFCcreti",
    roundTrip: "Gidi\u015F\u2013d\xF6n\xFC\u015F",
    estimate: "Tahmini",
    onRequest: "Fiyat talep \xFCzerine",
    available: "M\xFCsait",
    limited: "S\u0131n\u0131rl\u0131 m\xFCsaitlik",
    unavailable: "Se\xE7ili tarihte dolu",
    nearest: "En yak\u0131n m\xFCsait: {{date}}",
    capacity: {
      GUESTS: "{{count}} ki\u015Fiye kadar",
      PASSENGERS: "{{count}} yolcuya kadar",
      SEATS: "{{count}} koltuk",
      ROOMS: "{{count}} oda",
      BEDROOMS: "{{count}} yatak odas\u0131"
    },
    featured: "\xD6ne \xE7\u0131kan",
    favoriteAdd: "Favorilere ekle",
    favoriteRemove: "Favorilerden \xE7\u0131kar",
    favoriteLogin: "Favorilere eklemek i\xE7in giri\u015F yap\u0131n.",
    gallery: "{{name}} galerisi",
    representative: "Temsil\xEE g\xF6rsel",
    details: "\u0130ncele"
  },
  detail: {
    locationStay: "Konum",
    locationExperience: "Bulu\u015Fma noktas\u0131",
    features: "\xD6zellikler",
    allPhotos: "T\xFCm foto\u011Fraflar",
    about: "Hakk\u0131nda",
    specs: "Teknik \xF6zellikler",
    amenities: "Donan\u0131mlar",
    location: "Kalk\u0131\u015F noktas\u0131",
    availability: "M\xFCsaitlik takvimi",
    legend: { available: "M\xFCsait", partial: "K\u0131smen dolu", unavailable: "Dolu" },
    addOns: "Ekstralar",
    included: "Dahil",
    cancellation: "\u0130ptal politikas\u0131",
    refundBefore: "Ba\u015Flang\u0131\xE7tan {{hours}} saat \xF6ncesine kadar: %{{percent}} iade",
    refundLast: "Sonras\u0131nda: %{{percent}} iade",
    faq: "S\u0131k sorulan sorular",
    reviews: "Misafir yorumlar\u0131",
    reviewsCount: "Yorum: {{count}}",
    noReviews: "Hen\xFCz yorum yok.",
    reply: "DuvaMarine yan\u0131t\u0131",
    similar: "Benzer ilanlar",
    video: "Video",
    backToResults: "Sonu\xE7lara d\xF6n",
    notFound: "Bu ilan yay\u0131nda de\u011Fil veya kald\u0131r\u0131lm\u0131\u015F."
  },
  booking: {
    title: "Rezervasyon",
    from: "Ba\u015Flayan fiyat",
    date: "Tarih",
    duration: "S\xFCre",
    guests: "Ki\u015Fi",
    period: "Al\u0131\u015F \u2013 iade",
    pickupTime: "Al\u0131\u015F saati",
    returnTime: "\u0130ade saati",
    addOns: "Ekstralar",
    deposit: "Kapora: %{{percent}}",
    minimum: "Minimum: {{value}}",
    notice: "En az {{hours}} saat \xF6nceden",
    request: "Rezervasyon talebi g\xF6nder",
    quote: "Teklif iste",
    mobileCta: "Rezervasyon yap",
    dayUnavailable: "Se\xE7ili g\xFCn dolu, ba\u015Fka bir tarih deneyin.",
    askAdvisor: "Dan\u0131\u015Fmana sor",
    whatsapp: "WhatsApp",
    callback: "Beni aray\u0131n",
    whatsappText: "Merhaba, {{name}} hakk\u0131nda bilgi almak istiyorum.",
    startTime: "Ba\u015Flang\u0131\xE7 saati",
    returnAt: "D\xF6n\xFC\u015F transferi",
    quantity: "Adet",
    calculating: "Fiyat hesaplan\u0131yor\u2026",
    total: "Toplam",
    breakdown: "Fiyat d\xF6k\xFCm\xFC",
    approx: "\u2248 {{amount}}",
    chargedIn: "\xD6deme {{currency}} \xFCzerinden al\u0131n\u0131r; g\xF6sterilen kar\u015F\u0131l\u0131k yakla\u015F\u0131kt\u0131r.",
    coupon: "Kupon kodu",
    couponPlaceholder: "Kodunuz",
    couponApply: "Uygula",
    couponRemove: "Kald\u0131r",
    couponStatus: {
      APPLIED: "{{code}} uyguland\u0131",
      INVALID: "Ge\xE7ersiz kupon kodu",
      NOT_STARTED: "Bu kupon hen\xFCz ge\xE7erli de\u011Fil",
      EXPIRED: "Kuponun s\xFCresi dolmu\u015F",
      EXHAUSTED: "Kuponun kullan\u0131m limiti dolmu\u015F",
      ALREADY_USED: "Bu kuponu daha \xF6nce kulland\u0131n\u0131z",
      CATEGORY: "Kupon bu hizmet i\xE7in ge\xE7erli de\u011Fil",
      MIN_ORDER: "En az {{amount}} tutar\u0131ndaki rezervasyonlarda ge\xE7erli",
      CURRENCY: "Kupon \u015Fu anda uygulanam\u0131yor"
    },
    continue: "Rezervasyona devam et",
    continueRequest: "Talebe devam et",
    instantNote: "An\u0131nda onay: \xF6demeyle birlikte rezervasyonunuz kesinle\u015Fir.",
    requestNote: "Onayl\u0131 talep: kart\u0131n\u0131zdan \xF6n provizyon al\u0131n\u0131r, dan\u0131\u015Fman\u0131n\u0131z onaylad\u0131\u011F\u0131nda tahsil edilir.",
    issues: {
      REQUIRED: "L\xFCtfen se\xE7in: {{field}}.",
      START_TIME_REQUIRED: "Ba\u015Flang\u0131\xE7 saatini se\xE7in.",
      RETURN_REQUIRED: "D\xF6n\xFC\u015F transferi i\xE7in tarih ve saat se\xE7in.",
      INVALID_RANGE: "Se\xE7ilen tarih ve saat aral\u0131\u011F\u0131 uygun de\u011Fil.",
      NOT_BOOKABLE: "Bu se\xE7im \xE7evrim i\xE7i rezerve edilemiyor; dan\u0131\u015Fman\u0131m\u0131z yard\u0131mc\u0131 olsun.",
      NO_RATE: "Bu s\xFCre birimi i\xE7in fiyat tan\u0131ml\u0131 de\u011Fil.",
      NO_FARE: "Bu g\xFCzerg\xE2h ve ara\xE7 i\xE7in \xFCcret tan\u0131ml\u0131 de\u011Fil.",
      MIN_DURATION: "Minimum s\xFCre: {{value}}.",
      ADD_ON_UNAVAILABLE: "Se\xE7ilen ekstra art\u0131k sunulmuyor.",
      ADD_ON_LEAD_TIME: "Bu ekstra i\xE7in daha erken rezervasyon gerekir.",
      CURRENCY: "Kur bilgisi al\u0131namad\u0131; l\xFCtfen daha sonra deneyin.",
      UNAVAILABLE: "Se\xE7ilen zaman diliminde m\xFCsait de\u011Fil.",
      NOTICE: "En az {{hours}} saat \xF6nceden rezervasyon yap\u0131labilir.",
      CAPACITY: "En fazla {{limit}} ki\u015Fi.",
      NO_ROUTE: "Bu g\xFCzerg\xE2h i\xE7in \xE7evrim i\xE7i \xFCcret yok; dan\u0131\u015Fman\u0131m\u0131zdan teklif al\u0131n.",
      UNKNOWN_LOCATION: "Se\xE7ilen konum bulunamad\u0131."
    },
    addOnPricing: {
      PER_BOOKING: "rezervasyon",
      PER_PERSON: "ki\u015Fi",
      PER_HOUR: "saat",
      PER_DAY: "g\xFCn",
      PER_UNIT: "adet"
    }
  },
  experiences: {
    title: "Deneyimler",
    subtitle: "Kapadokya\u2019da \u015Fafakta size ayr\u0131lm\u0131\u015F bir balondan Bo\u011Faz\u2019da \u015Fefin haz\u0131rlad\u0131\u011F\u0131 ak\u015Fam yeme\u011Fine: T\xFCrkiye\u2019nin en se\xE7kin anlar\u0131, yaln\u0131zca size \xF6zel.",
    eyebrow: "DuvaMarine Deneyimleri",
    journeysTitle: "\u0130mza Rotalar",
    journeysLead: "Konaklama, ula\u015F\u0131m ve deneyimleri tek bir hik\xE2yede birle\u015Ftiren, uzmanlar\u0131m\u0131z\u0131n kurgulad\u0131\u011F\u0131 \xE7ok gecelik rotalar.",
    privateTitle: "\xD6zel deneyimler",
    privateLead: "Yaln\u0131zca sizin i\xE7in a\xE7\u0131lan anlar; tarihinizi ve saatinizi se\xE7in, gerisini ekibimiz haz\u0131rlar.",
    allPrivate: "T\xFCm \xF6zel deneyimler",
    conciergeTitle: "Hayalinizdeki an\u0131 birlikte tasarlayal\u0131m",
    conciergeBody: "Evlilik teklifi, y\u0131ld\xF6n\xFCm\xFC ya da kurumsal bir davet\u2026 Concierge ekibimiz her ayr\u0131nt\u0131y\u0131 sizin i\xE7in kurgular.",
    conciergeCta: "Concierge ile g\xF6r\xFC\u015F\xFCn",
    empty: "\u015Eu anda yay\u0131nda deneyim yok; concierge ekibimiz size \xF6zel bir program haz\u0131rlayabilir.",
    journey: {
      plan: "Kendi seyahatimi planla",
      back: "T\xFCm deneyimler",
      highlights: "\xD6ne \xE7\u0131kanlar",
      itinerary: "G\xFCn g\xFCn rota",
      day: "{{day}}. g\xFCn",
      inclusions: "Neler dahil",
      route: "Rotadaki se\xE7kiler",
      request: "Bu rotay\u0131 talep et",
      requestNote: "Rotay\u0131 tarihlerinize ve misafir say\u0131n\u0131za g\xF6re uyarlar, 24 saat i\xE7inde ki\u015Fisel teklifle d\xF6neriz.",
      priceNote: "Tarihlere ve misafir say\u0131s\u0131na g\xF6re de\u011Fi\u015Fir.",
      onRequest: "Fiyat talep \xFCzerine",
      notFound: "Rota bulunamad\u0131",
      leadTitle: "Rota talebi"
    }
  },
  stay: {
    roomsTitle: "Odalar ve s\xFCitler",
    roomsLead: "Bir oda tipi se\xE7in; fiyat ve m\xFCsaitlik se\xE7ti\u011Finiz tarihlere g\xF6re hesaplan\u0131r.",
    perRoom: "Oda ba\u015F\u0131na en fazla {{count}} misafir",
    roomCount: "Bu tipte {{count}} oda",
    select: "Bu oday\u0131 se\xE7",
    selected: "Se\xE7ili oda",
    change: "Oda tipini de\u011Fi\u015Ftir",
    choose: "Rezervasyon i\xE7in bir oda tipi se\xE7in.",
    chooseCta: "Odalar\u0131 g\xF6r",
    perNightFrom: "Gecelik ba\u015Flang\u0131\xE7",
    checkIn: "Giri\u015F {{time}} itibar\u0131yla",
    checkOut: "\xC7\u0131k\u0131\u015F {{time}}\u2019e kadar",
    loading: "Oda bilgileri y\xFCkleniyor\u2026"
  },
  sale: {
    location: "Bulundu\u011Fu yer",
    askingPrice: "Sat\u0131\u015F fiyat\u0131",
    priceOnRequest: "Fiyat talep \xFCzerine",
    converted: "G\xF6sterilen tutar g\xFCncel kurla \xE7evrilmi\u015Ftir; sat\u0131\u015F ilan\u0131n kendi para biriminde yap\u0131l\u0131r.",
    status: {
      AVAILABLE: "Sat\u0131\u015Fta",
      UNDER_OFFER: "Teklif a\u015Famas\u0131nda",
      SOLD: "Sat\u0131ld\u0131"
    },
    inquire: "Bilgi ve dosya talep et",
    inquireSimilar: "Benzer f\u0131rsatlar i\xE7in dan\u0131\u015F\u0131n",
    soldNote: "Bu ilan sat\u0131ld\u0131. Portf\xF6y\xFCm\xFCzde ve ilana \xE7\u0131kmam\u0131\u015F \xF6zel f\u0131rsatlarda benzerlerini sizin i\xE7in arayabiliriz.",
    viewing: {
      title: "\xD6zel g\xF6sterim",
      mode: "G\xF6sterim t\xFCr\xFC",
      preferredDate: "Tercih etti\u011Finiz tarih",
      cta: "\xD6zel g\xF6sterim talep et",
      modes: {
        IN_PERSON: "Yerinde",
        VIDEO: "Video g\xF6r\xFC\u015Fme",
        SEA_TRIAL: "Deneme seyri",
        TEST_FLIGHT: "Test u\xE7u\u015Fu",
        TEST_DRIVE: "Test s\xFCr\xFC\u015F\xFC"
      }
    },
    discretion: "T\xFCm g\xF6r\xFC\u015Fmeler gizlilik i\xE7inde y\xFCr\xFCt\xFCl\xFCr; bilgileriniz \xFC\xE7\xFCnc\xFC ki\u015Filerle payla\u015F\u0131lmaz.",
    advisory: "Teknik dosya, ekspertiz ve finansman s\xFCre\xE7lerinde dan\u0131\u015Fman\u0131n\u0131z size e\u015Flik eder.",
    whatsappText: "Merhaba, {{name}} ilan\u0131 hakk\u0131nda bilgi almak istiyorum.",
    mobileCta: "Bilgi al"
  },
  lead: {
    saleTitle: "Sat\u0131\u015F bilgisi talebi",
    saleSubtitle: "\u0130lan\u0131n teknik dosyas\u0131n\u0131, fiyat detaylar\u0131n\u0131 ve g\xF6r\xFC\u015Fme se\xE7eneklerini dan\u0131\u015Fman\u0131n\u0131z size iletsin.",
    viewingTitle: "\xD6zel g\xF6sterim talebi",
    viewingSubtitle: "Tercih etti\u011Finiz g\xF6sterim t\xFCr\xFCn\xFC ve tarihi dan\u0131\u015Fman\u0131n\u0131z teyit etsin; t\xFCm g\xF6r\xFC\u015Fmeler gizlidir.",
    bookingTitle: "Rezervasyon talebi",
    bookingSubtitle: "Se\xE7imlerinizi dan\u0131\u015Fman\u0131n\u0131za iletelim; m\xFCsaitlik ve kesin fiyatla size d\xF6nelim.",
    charterTitle: "Charter teklifi",
    charterSubtitle: "Rotan\u0131z\u0131 charter masam\u0131za iletelim; uygun u\xE7aklar ve kesin fiyatla d\xF6nelim.",
    callbackTitle: "Sizi arayal\u0131m",
    callbackSubtitle: "Dan\u0131\u015Fman\u0131m\u0131z size tercih etti\u011Finiz kanaldan ula\u015Fs\u0131n.",
    firstName: "Ad",
    lastName: "Soyad",
    email: "E-posta",
    phone: "Telefon",
    message: "Notunuz",
    messagePlaceholder: "Kutlama, men\xFC tercihi, transfer ihtiyac\u0131\u2026",
    channel: "Size nas\u0131l ula\u015Fal\u0131m?",
    channels: { PHONE: "Telefon", WHATSAPP: "WhatsApp", EMAIL: "E-posta" },
    contactHint: "Telefon veya e-postadan en az birini girin.",
    kvkk: "<kvkk>KVKK ayd\u0131nlatma metnini</kvkk> okudum; talebim i\xE7in benimle ileti\u015Fime ge\xE7ilmesini kabul ediyorum.",
    marketing: "Kampanya ve ayr\u0131cal\u0131klardan haberdar olmak istiyorum.",
    summary: "Talep \xF6zeti",
    submit: "Talebi g\xF6nder",
    success: "Talebiniz al\u0131nd\u0131. Dan\u0131\u015Fman\u0131n\u0131z en k\u0131sa s\xFCrede sizinle ileti\u015Fime ge\xE7ecek."
  },
  account: {
    profile: "Profil bilgileri",
    profileHint: "Rezervasyon ve talep formlar\u0131 bu bilgilerle dolu a\xE7\u0131l\u0131r.",
    profileSave: "Kaydet",
    profileSaved: "Profiliniz g\xFCncellendi.",
    title: "Hesab\u0131m",
    welcome: "Ho\u015F geldiniz, {{name}}",
    emailVerified: "E-posta do\u011Fruland\u0131",
    emailNotVerified: "E-posta adresiniz hen\xFCz do\u011Frulanmad\u0131",
    favorites: "Favorilerim",
    favoritesEmpty: "Hen\xFCz favori eklemediniz.",
    browse: "Filoyu ke\u015Ffedin",
    comingSoon: "Kay\u0131tl\u0131 yolcular\u0131n\u0131z yak\u0131nda burada olacak.",
    bookings: {
      title: "Rezervasyonlar\u0131m",
      tabs: { UPCOMING: "Yakla\u015Fan", PAST: "Ge\xE7mi\u015F", CANCELLED: "\u0130ptal edilenler" },
      empty: {
        UPCOMING: "Yakla\u015Fan rezervasyonunuz yok.",
        PAST: "Ge\xE7mi\u015F rezervasyonunuz yok.",
        CANCELLED: "\u0130ptal edilen rezervasyonunuz yok."
      },
      view: "G\xF6r\xFCnt\xFCle",
      cancellationRequested: "\u0130ptal talebi iletildi",
      paid: "\xD6denen: {{amount}}"
    },
    finance: {
      title: "Faturalar\u0131m ve \xF6demelerim",
      payments: "\xD6demeler",
      invoices: "Faturalar",
      noPayments: "Hen\xFCz \xF6demeniz yok.",
      noInvoices: "Hen\xFCz kesilmi\u015F faturan\u0131z yok."
    },
    privacy: {
      title: "Ki\u015Fisel verilerim",
      intro: "KVKK kapsam\u0131ndaki haklar\u0131n\u0131z\u0131 buradan kullanabilirsiniz: verilerinizin bir kopyas\u0131n\u0131 indirebilir veya hesab\u0131n\u0131z\u0131n silinmesini isteyebilirsiniz.",
      policy: "Ayd\u0131nlatma metni",
      export: {
        title: "Verilerimi indir",
        body: "Hesab\u0131n\u0131z, rezervasyonlar\u0131n\u0131z, \xF6demeleriniz ve izinleriniz tek bir JSON dosyas\u0131nda. Dosya {{days}} g\xFCn boyunca buradan yeniden indirilebilir.",
        action: "Verilerimi indir",
        ready: "Veri dosyan\u0131z indirildi."
      },
      deletion: {
        title: "Hesab\u0131m\u0131 sil",
        body: "Hesab\u0131n\u0131z kapat\u0131l\u0131r ve ki\u015Fisel verileriniz anonimle\u015Ftirilir. Fatura, \xF6deme ve rezervasyon kay\u0131tlar\u0131 yasal saklama s\xFCreleri boyunca saklan\u0131r. Devam eden bir rezervasyonunuz varsa talebiniz o tamamland\u0131ktan sonra sonu\xE7lan\u0131r.",
        action: "Hesab\u0131m\u0131n silinmesini iste",
        confirmTitle: "Hesab\u0131n\u0131z silinsin mi?",
        confirmBody: "Talebiniz ekibimizce incelenir ve en ge\xE7 30 g\xFCn i\xE7inde sonu\xE7land\u0131r\u0131l\u0131r; sonucu e-postayla bildiririz. Silme i\u015Fleminden sonra hesab\u0131n\u0131za giri\u015F yapamazs\u0131n\u0131z ve bu i\u015Flem geri al\u0131namaz.",
        reason: "Nedeni (iste\u011Fe ba\u011Fl\u0131)",
        confirm: "Silme talebini g\xF6nder",
        sent: "Talebiniz al\u0131nd\u0131. Sonucu e-postayla bildirece\u011Fiz.",
        pending: "Silme talebiniz inceleniyor."
      },
      history: "Taleplerim",
      types: { EXPORT: "Veri indirme", DELETION: "Hesap silme" },
      statuses: {
        PENDING: "Bekliyor",
        IN_PROGRESS: "\u0130nceleniyor",
        COMPLETED: "Tamamland\u0131",
        REJECTED: "Reddedildi"
      },
      download: "\u0130ndir",
      downloadUntil: "{{date}} tarihine kadar indirilebilir",
      note: "Ekibin notu: {{note}}"
    }
  },
  notFound: {
    title: "Rota bulunamad\u0131",
    body: "Arad\u0131\u011F\u0131n\u0131z sayfa ta\u015F\u0131nm\u0131\u015F ya da hi\xE7 var olmam\u0131\u015F olabilir.",
    cta: "Ana sayfaya d\xF6n"
  },
  checkout: {
    title: "Rezervasyon",
    steps: {
      details: "Detaylar",
      guest: "Misafir bilgileri",
      payment: "\xD6deme",
      confirmation: "Onay"
    },
    summary: "Rezervasyon \xF6zeti",
    edit: "Se\xE7imi de\u011Fi\u015Ftir",
    back: "Geri",
    continue: "Devam et",
    extras: "Ekstralar",
    policy: "\u0130ptal politikas\u0131",
    contactTitle: "\u0130leti\u015Fim bilgileri",
    contactHint: "Onay e-postas\u0131 ve SMS bu bilgilere g\xF6nderilir.",
    firstName: "Ad",
    lastName: "Soyad",
    email: "E-posta",
    phone: "Telefon",
    phoneHint: "\xDClke kodunu se\xE7ip numaran\u0131z\u0131 yaz\u0131n.",
    travellersTitle: "Yolcu bilgileri",
    travellersHint: "U\xE7u\u015F manifestosu i\xE7in her yolcunun kimlik bilgileri gereklidir.",
    traveller: "{{index}}. yolcu",
    nationality: "Uyruk (\xFClke kodu, \xF6rn. TR)",
    documentType: "Belge t\xFCr\xFC",
    documentTypes: { PASSPORT: "Pasaport", NATIONAL_ID: "Kimlik kart\u0131", OTHER: "Di\u011Fer" },
    documentNumber: "Belge numaras\u0131",
    specialRequests: "\xD6zel istekleriniz",
    specialRequestsPlaceholder: "Kutlama, men\xFC tercihi, kar\u015F\u0131lama, alerjiler\u2026",
    signedInAs: "{{email}} hesab\u0131yla devam ediyorsunuz.",
    haveAccount: "\xDCye misiniz? <login>Giri\u015F yap\u0131n</login>; rezervasyonlar\u0131n\u0131z hesab\u0131n\u0131zda toplans\u0131n.",
    createAccount: "Bu bilgilerle bir hesap olu\u015Ftur",
    createAccountHint: "Rezervasyonlar\u0131n\u0131z\u0131, voucher ve faturalar\u0131n\u0131z\u0131 tek yerden y\xF6netin.",
    password: "\u015Eifre",
    terms: "<sales>Mesafeli sat\u0131\u015F s\xF6zle\u015Fmesini</sales> ve <kvkk>KVKK ayd\u0131nlatma metnini</kvkk> okudum, iptal ko\u015Fullar\u0131n\u0131 kabul ediyorum.",
    marketing: "Kampanya ve ayr\u0131cal\u0131klardan e-posta ile haberdar olmak istiyorum.",
    toPayment: "\xD6deme ad\u0131m\u0131na ge\xE7",
    holdNote: "Devam etti\u011Finizde tarih {{minutes}} dakika boyunca sizin i\xE7in ayr\u0131l\u0131r.",
    unavailable: "Bu se\xE7im art\u0131k rezerve edilemiyor.",
    backToListing: "\u0130lana d\xF6n",
    guestCount: "Misafir: {{count}}"
  },
  bookingPage: {
    title: "Rezervasyon {{code}}",
    code: "Rezervasyon kodu",
    heroes: {
      DRAFT: { title: "Taslak rezervasyon", body: "Bu rezervasyon hen\xFCz tamamlanmad\u0131." },
      PENDING_PAYMENT: {
        title: "\xD6deme ad\u0131m\u0131",
        body: "Tarihiniz sizin i\xE7in ayr\u0131ld\u0131. \xD6demeyi tamamlayarak rezervasyonunuzu kesinle\u015Ftirin."
      },
      AWAITING_CONFIRMATION: {
        title: "Talebiniz al\u0131nd\u0131",
        body: "Kart\u0131n\u0131zdan \xF6n provizyon al\u0131nd\u0131. Dan\u0131\u015Fman\u0131n\u0131z m\xFCsaitli\u011Fi onaylad\u0131\u011F\u0131nda tahsil edilecek ve size haber verilecek."
      },
      CONFIRMED: {
        title: "Rezervasyonunuz onayland\u0131",
        body: "Onay e-postas\u0131 {{email}} adresine g\xF6nderildi. Voucher ve takvim dosyas\u0131n\u0131 a\u015Fa\u011F\u0131dan indirebilirsiniz."
      },
      IN_PROGRESS: {
        title: "Keyifli yolculuklar",
        body: "Hizmetiniz devam ediyor; dan\u0131\u015Fman\u0131n\u0131z her an yan\u0131n\u0131zda."
      },
      COMPLETED: {
        title: "Bizi tercih etti\u011Finiz i\xE7in te\u015Fekk\xFCrler",
        body: "Sizi yeniden a\u011F\u0131rlamay\u0131 d\xF6rt g\xF6zle bekliyoruz."
      },
      CANCELLED: { title: "Rezervasyon iptal edildi", body: "Bu rezervasyon iptal edildi." },
      REFUNDED: { title: "\u0130ade tamamland\u0131", body: "Bu rezervasyonun iadesi tamamland\u0131." },
      NO_SHOW: {
        title: "Rezervasyon kullan\u0131lmad\u0131",
        body: "Hizmet ba\u015Flang\u0131c\u0131nda gelinmedi\u011Fi i\xE7in rezervasyon kapat\u0131ld\u0131."
      }
    },
    holdRemaining: "Ay\u0131rma s\xFCresi: {{time}}",
    holdExpired: "Ay\u0131rma s\xFCresi doldu. Tarih yeniden m\xFCsaitse rezervasyonu ba\u015Ftan ba\u015Flatabilirsiniz.",
    planTitle: "\xD6deme se\xE7ene\u011Fi",
    planDeposit: "Kapora \xF6de",
    planDepositHint: "\u015Eimdi {{amount}}, kalan {{balance}} en ge\xE7 {{date}}",
    planFull: "Tamam\u0131n\u0131 \xF6de",
    planFullHint: "\u015Eimdi {{amount}}",
    fullOnly: "Ba\u015Flang\u0131ca az kald\u0131\u011F\u0131 i\xE7in tutar\u0131n tamam\u0131 \u015Fimdi \xF6denir.",
    pay: "{{amount}} \xF6de",
    authorize: "{{amount}} \xF6n provizyon al",
    payBalance: "Kalan bakiyeyi \xF6de ({{amount}})",
    secure: "3D Secure ile g\xFCvenli \xF6deme. Kart bilgileriniz DuvaMarine sunucular\u0131nda saklanmaz.",
    testMode: "Test modu: ger\xE7ek \xF6deme al\u0131nmaz.",
    test3ds: {
      title: "3D Secure do\u011Frulamas\u0131",
      subtitle: "Test \xF6deme sa\u011Flay\u0131c\u0131s\u0131 \xB7 {{amount}}",
      body: "Ger\xE7ek entegrasyonda bu ad\u0131m bankan\u0131z\u0131n g\xFCvenli sayfas\u0131nda ger\xE7ekle\u015Fir.",
      approve: "\xD6demeyi onayla",
      decline: "Reddet"
    },
    declined: "\xD6deme onaylanmad\u0131. Tekrar deneyebilirsiniz.",
    paid: "\xD6demeniz al\u0131nd\u0131.",
    details: "Rezervasyon bilgileri",
    listing: "\u0130lan",
    period: "Tarih",
    location: "Bulu\u015Fma noktas\u0131",
    route: "G\xFCzerg\xE2h",
    guests: "Ki\u015Fi",
    contact: "\u0130leti\u015Fim",
    travellers: "Yolcular",
    special: "\xD6zel istekler",
    price: "Fiyat d\xF6k\xFCm\xFC",
    payments: "\xD6demeler",
    paymentsEmpty: "Hen\xFCz \xF6deme yok.",
    balanceDue: "Kalan bakiye {{amount}} \xB7 son \xF6deme {{date}}",
    documents: "Belgeler",
    voucher: "Voucher (PDF)",
    calendar: "Takvime ekle",
    policy: "\u0130ptal politikas\u0131",
    cancel: {
      cancel: "Rezervasyonu iptal et",
      request: "\u0130ptal talebi g\xF6nder",
      reason: "\u0130ptal nedeni (iste\u011Fe ba\u011Fl\u0131)",
      confirmCancel: "Rezervasyonunuz iptal edilecek ve ayr\u0131lan tarih serbest b\u0131rak\u0131lacak.",
      confirmRequest: "Talebiniz dan\u0131\u015Fman\u0131n\u0131za iletilecek; iade tutar\u0131 iptal politikas\u0131na g\xF6re hesaplan\u0131r.",
      estimate: "\u015Eimdi iptal edilirse tahmini iade: {{amount}} (%{{percent}})",
      noRefund: "Politika gere\u011Fi bu a\u015Famada iade yap\u0131lmaz.",
      requested: "\u0130ptal talebiniz {{date}} tarihinde al\u0131nd\u0131; dan\u0131\u015Fman\u0131n\u0131z sizinle ileti\u015Fime ge\xE7ecek.",
      done: "Rezervasyon iptal edildi.",
      sent: "\u0130ptal talebiniz iletildi.",
      submit: "Onayla"
    },
    notFound: {
      title: "Rezervasyon bulunamad\u0131",
      body: "Ba\u011Flant\u0131n\u0131n eksiksiz oldu\u011Fundan emin olun ya da hesab\u0131n\u0131za giri\u015F yap\u0131n."
    },
    linkNote: "Bu sayfan\u0131n ba\u011Flant\u0131s\u0131 rezervasyonunuza eri\u015Fim sa\u011Flar; e-postan\u0131zda da bulunur.",
    accountCta: "Rezervasyonlar\u0131n\u0131z\u0131 tek yerden y\xF6netmek i\xE7in <register>hesap olu\u015Fturun</register>.",
    paymentReturn: {
      checking: "\xD6demeniz bankan\u0131zla do\u011Frulan\u0131yor, l\xFCtfen bekleyin\u2026",
      succeeded: "\xD6demeniz al\u0131nd\u0131. Te\u015Fekk\xFCr ederiz!",
      authorized: "Kart\u0131n\u0131zda \xF6n provizyon al\u0131nd\u0131; rezervasyon onaylan\u0131nca tahsil edilecek.",
      failed: "\xD6deme tamamlanamad\u0131. Kart\u0131n\u0131zdan \xE7ekim yap\u0131lmad\u0131; tekrar deneyebilirsiniz.",
      slow: "Bankan\u0131zdan yan\u0131t gecikiyor. Sonu\xE7 birka\xE7 dakika i\xE7inde bu sayfada ve e-postan\u0131zda g\xF6r\xFCnecek.",
      error: "\xD6deme durumu al\u0131namad\u0131. Sayfay\u0131 yenileyin ya da bizimle ileti\u015Fime ge\xE7in."
    },
    method: {
      CARD: "Kart",
      BANK_TRANSFER: "Havale/EFT",
      CASH: "Nakit",
      POS: "POS",
      PAYMENT_LINK: "\xD6deme ba\u011Flant\u0131s\u0131"
    },
    refundedPart: "\u0130ade: {{amount}}",
    refunds: "\u0130adeler",
    refundStatus: { PENDING: "\u0130\u015Fleniyor", SUCCEEDED: "\u0130ade edildi", FAILED: "\u0130\u015Fleniyor" },
    refundNote: "Kart iadelerinin hesab\u0131n\u0131za yans\u0131mas\u0131 bankan\u0131za g\xF6re 2\u201310 i\u015F g\xFCn\xFC s\xFCrebilir.",
    invoices: "Faturalar",
    invoiceType: { SALES: "Fatura", PROFORMA: "Proforma", CREDIT_NOTE: "\u0130ade faturas\u0131" },
    invoicePdf: "PDF indir",
    review: {
      heading: "De\u011Ferlendirmeniz",
      rating: "5 \xFCzerinden {{rating}} puan",
      statuses: {
        PENDING: "Onay bekliyor",
        APPROVED: "Yay\u0131nda",
        REJECTED: "Yay\u0131nlanmad\u0131"
      },
      reply: "DuvaMarine yan\u0131t\u0131",
      intro: "Deneyiminizi payla\u015F\u0131n; yorumunuz onayland\u0131ktan sonra ilan sayfas\u0131nda yay\u0131nlan\u0131r.",
      yourRating: "Puan\u0131n\u0131z",
      title: "Ba\u015Fl\u0131k (iste\u011Fe ba\u011Fl\u0131)",
      comment: "Yorumunuz",
      submit: "Yorumu g\xF6nder",
      thanks: "Te\u015Fekk\xFCrler! Yorumunuz incelendikten sonra yay\u0131nlanacak.",
      loginFirst: "Yorum yapmak i\xE7in hesab\u0131n\u0131za giri\u015F yap\u0131n."
    }
  },
  newsletterConfirm: {
    title: "B\xFClten aboneli\u011Fi",
    confirming: "Aboneli\u011Finiz onaylan\u0131yor\u2026",
    success: "Aboneli\u011Finiz onayland\u0131. Te\u015Fekk\xFCr ederiz!",
    failed: "Onay ba\u011Flant\u0131s\u0131 ge\xE7ersiz veya daha \xF6nce kullan\u0131lm\u0131\u015F.",
    home: "Ana sayfaya d\xF6n"
  },
  planner: {
    eyebrow: "Seyahat planlay\u0131c\u0131",
    title: "Seyahatinizi planlay\u0131n",
    subtitle: "Birka\xE7 tercihle size \xF6zel bir rota olu\u015Ftural\u0131m. Kaporayla ay\u0131r\u0131n; gerisini seyahat dan\u0131\u015Fman\u0131n\u0131z \xFCstlensin.",
    less: "{{label}} azalt",
    more: "{{label}} art\u0131r",
    next: "Devam et",
    back: "Geri",
    seeRoute: "Rotam\u0131 g\xF6ster",
    progress: "Ad\u0131m {{current}} / {{total}}",
    progressLabel: "Planlama ad\u0131mlar\u0131",
    loadFailed: "Planlay\u0131c\u0131 y\xFCklenemedi. L\xFCtfen tekrar deneyin.",
    onRequest: "Ekibimiz fiyatland\u0131r\u0131r",
    steps: {
      where: "Nereye",
      transport: "Ula\u015F\u0131m",
      stay: "Konaklama",
      sea: "Deniz & deneyim",
      car: "Ara\xE7",
      route: "Rotan\u0131z",
      contact: "\u0130leti\u015Fim"
    },
    headings: {
      where: "Nereye ve ne zaman?",
      transport: "Nas\u0131l geliyorsunuz?",
      stay: "Nerede kalmak istersiniz?",
      sea: "Denizde ne kadar vakit ge\xE7irelim?",
      car: "Yollarda sizi kim ta\u015F\u0131s\u0131n?",
      route: "Size \xF6zel rotan\u0131z",
      contact: "Son ad\u0131m: sizi tan\u0131yal\u0131m"
    },
    leads: {
      where: "Destinasyonu, tarihleri ve kimlerle geldi\u011Finizi se\xE7in.",
      transport: "Kar\u015F\u0131laman\u0131z\u0131 buna g\xF6re kurgular\u0131z.",
      stay: "Tarz\u0131n\u0131za en yak\u0131n se\xE7enekleri \xF6ne \xE7\u0131kar\u0131r\u0131z.",
      sea: "Yat g\xFCnlerini ve ilginizi \xE7eken deneyimleri belirtin.",
      car: "\u015Eof\xF6rl\xFC, kendiniz kullanarak ya da yaln\u0131zca havaliman\u0131 transferiyle.",
      route: "Her b\xF6l\xFCm tarihlerinize g\xF6re fiyatland\u0131. Alternatifler aras\u0131nda diledi\u011Finiz gibi de\u011Fi\u015Fiklik yap\u0131n.",
      contact: "Plan\u0131n\u0131z\u0131 g\xF6nderdikten sonra kaporay\u0131 g\xFCvenli \xF6deme sayfas\u0131nda \xF6dersiniz."
    },
    where: {
      destination: "Destinasyon",
      dates: "Tarihler",
      datesChoose: "Giri\u015F ve \xE7\u0131k\u0131\u015F tarihlerini se\xE7in",
      datesHint: "En fazla {{count}} gece; daha uzun seyahatler i\xE7in dan\u0131\u015Fman\u0131m\u0131z yan\u0131n\u0131zda.",
      adults: "Yeti\u015Fkin",
      children: "\xC7ocuk",
      occasion: "Seyahatin vesilesi",
      occasions: {
        LEISURE: "Tatil",
        HONEYMOON: "Balay\u0131",
        ANNIVERSARY: "Y\u0131l d\xF6n\xFCm\xFC",
        FAMILY: "Aile",
        FRIENDS: "Arkada\u015Flar",
        BUSINESS: "\u0130\u015F",
        CELEBRATION: "Kutlama"
      }
    },
    transport: {
      departure: "Kalk\u0131\u015F havaliman\u0131",
      departureHint: "Listede yoksa en yak\u0131n\u0131n\u0131 se\xE7in; dan\u0131\u015Fman\u0131n\u0131z d\xFCzenler.",
      departureChoose: "Havaliman\u0131 se\xE7in",
      options: {
        PRIVATE_JET: {
          title: "\xD6zel jet",
          body: "Se\xE7ti\u011Finiz havaliman\u0131ndan gidi\u015F-d\xF6n\xFC\u015F; fiyat aral\u0131\u011F\u0131yla tahminlenir."
        },
        VIP_ARRIVAL: {
          title: "Tarifeli u\xE7u\u015F + VIP kar\u015F\u0131lama",
          body: "Biletiniz sizde; havaliman\u0131nda kar\u015F\u0131lar ve transfer ederiz."
        },
        OWN_YACHT: {
          title: "Kendi yat\u0131mla",
          body: "Marinada kar\u015F\u0131lar, karadaki her \u015Feyi planlar\u0131z."
        },
        IN_TURKEY: {
          title: "Zaten T\xFCrkiye\u2019deyim",
          body: "Ula\u015F\u0131m gerekmez; do\u011Frudan seyahatinize ba\u015Flar\u0131z."
        }
      }
    },
    stay: {
      options: {
        PALACE: {
          title: "Saray oteli & resort",
          body: "Tarih\xEE saraylar ve deniz k\u0131y\u0131s\u0131nda tam hizmet resortlar."
        },
        BOUTIQUE: {
          title: "Butik otel",
          body: "Az odal\u0131, karakterli ve ki\u015Fisel hizmet sunan adresler."
        },
        VILLA: {
          title: "\xD6zel villa",
          body: "Size ayr\u0131lm\u0131\u015F havuz, mahremiyet ve ev ekibi."
        },
        NONE: {
          title: "Konaklama istemiyorum",
          body: "Konaklaman\u0131z\u0131 kendiniz ayarl\u0131yorsunuz."
        }
      }
    },
    sea: {
      yachtDays: "Yat g\xFCn\xFC",
      yachtHint: "Yat g\xFCnleri var\u0131\u015F\u0131n\u0131z\u0131n ertesi sabah\u0131 ba\u015Flar. Denize \xE7\u0131kmayacaksan\u0131z 0 b\u0131rak\u0131n.",
      interests: "\u0130lgi alanlar\u0131n\u0131z",
      interestOptions: {
        GASTRONOMY: "Gastronomi",
        CULTURE: "K\xFClt\xFCr & tarih",
        WELLNESS: "Wellness",
        ADVENTURE: "G\xF6ky\xFCz\xFC & macera",
        SEA: "Deniz",
        NIGHTLIFE: "Gece hayat\u0131"
      }
    },
    car: {
      options: {
        NONE: {
          title: "Ara\xE7 istemiyorum",
          body: "Ula\u015F\u0131m\u0131 gerekti\u011Finde ayr\u0131ca ayarlar\u0131z."
        },
        SELF_DRIVE: {
          title: "Kendim kullan\u0131r\u0131m",
          body: "Seyahat boyunca se\xE7kin bir ara\xE7."
        },
        CHAUFFEUR: {
          title: "Tam g\xFCn \u015Fof\xF6rl\xFC",
          body: "Seyahat boyunca arac\u0131n\u0131z ve \u015Fof\xF6r\xFCn\xFCz haz\u0131r."
        },
        TRANSFERS: {
          title: "Yaln\u0131zca transfer",
          body: "Havaliman\u0131 kar\u015F\u0131lama ve d\xF6n\xFC\u015F transferi."
        }
      }
    },
    route: {
      segments: {
        JET: "\xD6zel jetiniz",
        TRANSFER: "Havaliman\u0131 transferleri",
        STAY: "Konaklaman\u0131z",
        YACHT: "Yat g\xFCnleriniz",
        EXPERIENCE: "Deneyimler",
        CAR: "Arac\u0131n\u0131z"
      },
      viewListing: "\u0130lan\u0131 incele",
      missing: "Bu tarihlerde uygun {{part}} se\xE7ene\u011Fi bulamad\u0131k. Notlar\u0131n\u0131zda belirtin, dan\u0131\u015Fman\u0131n\u0131z ilgilensin.",
      remove: "Bu b\xF6l\xFCm\xFC \xE7\u0131kar",
      pickMany: "Diledi\u011Finiz kadar\u0131n\u0131 se\xE7in.",
      itinerary: "G\xFCn g\xFCn seyahatiniz",
      day: "{{day}}. g\xFCn",
      until: "{{day}}. g\xFCne kadar",
      arrive: "{{airport}} var\u0131\u015F ve kar\u015F\u0131lama",
      depart: "D\xF6n\xFC\u015F",
      freeDay: "Serbest g\xFCn; dan\u0131\u015Fman\u0131n\u0131z \xF6nerilerle yan\u0131n\u0131zda.",
      summary: "Plan \xF6zeti",
      estimate: "Tahmini toplam",
      deposit: "Kapora (%{{percent}})",
      onRequestNote: "Fiyat\u0131 ekibimizin belirleyece\u011Fi b\xF6l\xFCm: {{count}}. Kesin toplam onayda netle\u015Fir.",
      depositNote: "B\xF6l\xFCmler ekibimizce teyit edilir; kesin toplam onaylan\u0131nca kalan bakiye istenir.",
      empty: "Devam etmek i\xE7in en az bir b\xF6l\xFCm se\xE7in.",
      failed: "Rotan\u0131z\u0131 olu\u015Fturamad\u0131k. L\xFCtfen tercihlerinizi kontrol edip tekrar deneyin.",
      restart: "Ba\u015Fa d\xF6n",
      loading: "Rotan\u0131z haz\u0131rlan\u0131yor\u2026"
    },
    contact: {
      notes: "Notlar\u0131n\u0131z",
      notesHint: "\xD6zel g\xFCnler, beslenme tercihleri, s\xFCrpriz istekler\u2026",
      submit: "Plan\u0131 g\xF6nder ve kaporaya ge\xE7"
    },
    part: {
      nights: "{{count}} gece",
      days: "{{count}} g\xFCn",
      roundTrip: "gidi\u015F-d\xF6n\xFC\u015F",
      withDriver: "\u015Fof\xF6rl\xFC",
      selfDrive: "kendiniz kullan\u0131rs\u0131n\u0131z"
    },
    plan: {
      title: "Seyahat plan\u0131 {{code}}",
      party: "{{adults}} yeti\u015Fkin, {{children}} \xE7ocuk",
      status: {
        SUBMITTED: "Plan\u0131n\u0131z haz\u0131r. Kaporay\u0131 \xF6dedi\u011Finizde ekibimiz her b\xF6l\xFCm\xFC sizin i\xE7in ay\u0131rmaya ba\u015Flar.",
        DEPOSIT_PAID: "Kaporan\u0131z al\u0131nd\u0131. Seyahat dan\u0131\u015Fman\u0131n\u0131z her b\xF6l\xFCm\xFC teyit edip kesin fiyatla size d\xF6necek.",
        IN_REVIEW: "Dan\u0131\u015Fman\u0131n\u0131z plan\u0131n\u0131z \xFCzerinde \xE7al\u0131\u015F\u0131yor; b\xF6l\xFCmleri sa\u011Flay\u0131c\u0131larla teyit ediyor.",
        CONFIRMED: "Seyahatiniz onayland\u0131. Kesin toplam ve kalan bakiye yanda.",
        COMPLETED: "Seyahatiniz tamamland\u0131. Bizi tercih etti\u011Finiz i\xE7in te\u015Fekk\xFCr ederiz.",
        CANCELLED: "Bu plan iptal edildi. Yeni bir plan i\xE7in her zaman buraday\u0131z.",
        EXPIRED: "Kapora s\xFCresi doldu\u011Fu i\xE7in bu plan kapand\u0131. Diledi\u011Finizde yeni bir plan olu\u015Fturabilirsiniz."
      },
      parts: "Seyahatiniz",
      days: "{{from}}\u2013{{to}}. g\xFCn",
      totals: "Tutarlar",
      confirmed: "Onaylanan toplam",
      deposit: "Kapora",
      paid: "\xD6denen",
      balance: "Kalan bakiye",
      payDeposit: "{{amount}} kaporay\u0131 \xF6de",
      payBalance: "{{amount}} bakiyeyi \xF6de",
      expires: "Kapora son tarihi: {{date}}",
      payments: "\xD6demeler",
      notFound: "Bu plan bulunamad\u0131",
      notFoundBody: "Plan\u0131n\u0131za e-postadaki ba\u011Flant\u0131dan veya hesab\u0131n\u0131zdan ula\u015Fabilirsiniz."
    },
    mine: {
      title: "Seyahatlerim",
      new: "Yeni seyahat planla",
      empty: "Hen\xFCz planlad\u0131\u011F\u0131n\u0131z bir seyahat yok."
    }
  },
  ownerServices: {
    eyebrow: "Sahiplere \xF6zel",
    title: "Sahip hizmetleri",
    subtitle: "Yat\u0131n\u0131z\u0131n, jetinizin, arac\u0131n\u0131z\u0131n ve evinizin bak\u0131m\u0131, ekibi, sat\u0131\u015F\u0131 ve g\xFCndelik ayr\u0131cal\u0131klar\u0131 \u2014 kendi filomuzu y\xF6neten ekip taraf\u0131ndan planlan\u0131r, fiyatland\u0131r\u0131l\u0131r ve y\xFCr\xFCt\xFCl\xFCr.",
    loadFailed: "Sahip hizmetleri y\xFCklenemedi. L\xFCtfen tekrar deneyin.",
    request: "Hizmet talep et",
    details: "Detaylar",
    notFound: "Bu hizmet bulunamad\u0131.",
    all: "T\xFCm sahip hizmetleri",
    scope: "Neleri \xFCstleniyoruz",
    process: "Nas\u0131l \xE7al\u0131\u015F\u0131r",
    references: "Referanslar",
    faq: "S\u0131k\xE7a sorulan sorular",
    stats: "Rakamlarla",
    packages: "Paketler ve hizmet seviyeleri",
    packagesLead: "\u0130htiyac\u0131n\u0131za uygun seviyeyi se\xE7in; her paket ki\u015Fiye \xF6zel uyarlan\u0131r.",
    response: "Yan\u0131t s\xFCresi",
    from: "Ba\u015Flang\u0131\xE7",
    onRequest: "Fiyat talep \xFCzerine",
    period: { MONTH: "/ ay", YEAR: "/ y\u0131l", JOB: "/ i\u015F" },
    popular: "En \xE7ok tercih edilen",
    choosePackage: "Bu paketle talep et",
    guarantees: "G\xFCvencelerimiz",
    ctaTitle: "\u0130htiyac\u0131n\u0131z\u0131 anlat\u0131n",
    ctaBody: "Birka\xE7 bilgi ve foto\u011Frafla talep g\xF6nderin; online onaylayabilece\u011Finiz kalem kalem bir teklifle d\xF6nelim."
  },
  assetForm: {
    name: {
      YACHT: "Yat ad\u0131",
      JET: "U\xE7ak ad\u0131 veya takma ad\u0131",
      CAR: "Ara\xE7 (\xF6r. Range Rover Autobiography)",
      RESIDENCE: "Konut (\xF6r. Villa Serein)"
    },
    make: {
      YACHT: "Tersane",
      JET: "\xDCretici",
      CAR: "Marka",
      RESIDENCE: "Konut tipi (villa, daire, yal\u0131\u2026)"
    },
    model: "Model",
    year: "Y\u0131l",
    registration: {
      YACHT: "Sicil / bayrak no.",
      JET: "Kuyruk tescili",
      CAR: "Plaka",
      RESIDENCE: "Tapu / ada-parsel no."
    },
    length: "Boy (m)",
    homeLocation: {
      YACHT: "Ba\u011Fl\u0131 oldu\u011Fu marina",
      JET: "Ba\u011Fl\u0131 oldu\u011Fu havaliman\u0131"
    },
    noLocation: "Listede yok",
    locationText: "Konum / adres",
    locationTextHint: "Listede yoksa marina iskelesi, hangar veya adres.",
    notes: "Varl\u0131kla ilgili notlar"
  },
  serviceRequest: {
    title: "Hizmet talebi",
    subtitle: "Hizmetleri se\xE7in, varl\u0131\u011F\u0131n\u0131z\u0131 ve size uygun zaman\u0131 anlat\u0131n. Talep g\xF6ndermek \xFCcretsizdir.",
    itemsTitle: "Hizmetler",
    itemsHint: "Teklif almak istedi\u011Finiz t\xFCm kalemleri se\xE7in.",
    assetTitle: {
      YACHT: "Yat\u0131n\u0131z",
      JET: "U\xE7a\u011F\u0131n\u0131z",
      CAR: "Arac\u0131n\u0131z",
      RESIDENCE: "Konutunuz",
      ANY: "Varl\u0131\u011F\u0131n\u0131z"
    },
    assetType: "Varl\u0131k t\xFCr\xFC",
    packageNote: "Se\xE7ilen paket: {{name}}",
    newAsset: "+ Yeni ekle",
    saveAsset: "Sonraki talepler i\xE7in hesab\u0131ma kaydet",
    whenTitle: "Tercih edilen tarihler",
    whenHint: "\u0130ste\u011Fe ba\u011Fl\u0131 \u2014 esnekseniz bo\u015F b\u0131rak\u0131n.",
    from: "Ba\u015Flang\u0131\xE7",
    to: "Biti\u015F",
    detailsTitle: "Detaylar ve foto\u011Fraflar",
    notes: "Notlar",
    notesPlaceholder: "Belirtiler, son bak\u0131m tarihi, iskele veya hangara eri\u015Fim\u2026",
    photos: "Foto\u011Fraflar",
    photosHint: "En fazla {{count}} foto\u011Fraf (JPEG, PNG, WebP veya AVIF). Dosyalardaki konum bilgisi silinir.",
    addPhotos: "Foto\u011Fraf ekle",
    removePhoto: "Foto\u011Fraf\u0131 kald\u0131r",
    photoTooLarge: "20 MB \xFCzerindeki foto\u011Fraflar eklenmedi.",
    photoLimit: "En fazla {{count}} foto\u011Fraf ekleyebilirsiniz.",
    nextSteps: "Ekibimiz talebinizi inceler ve kalem kalem teklifi e-postayla g\xF6nderir. Teklifi online onaylars\u0131n\u0131z; i\u015F, onaydan sonra planlan\u0131r.",
    submit: "Talebi g\xF6nder",
    fixErrors: "L\xFCtfen i\u015Faretli alanlar\u0131 kontrol edin.",
    created: "{{code}} numaral\u0131 talebiniz al\u0131nd\u0131."
  },
  serviceRequestPage: {
    title: "Hizmet talebi {{code}}",
    heroes: {
      NEW: {
        title: "Talebiniz al\u0131nd\u0131",
        body: "Te\u015Fekk\xFCrler. Ekibimiz talebinizi inceleyip teklifle size d\xF6necek."
      },
      REVIEWING: {
        title: "Talebinizi inceliyoruz",
        body: "Teklifinizi haz\u0131rlamak i\xE7in kapsam\u0131, par\xE7alar\u0131 ve uygunlu\u011Fu kontrol ediyoruz."
      },
      QUOTE_SENT: {
        title: "Teklifiniz haz\u0131r",
        body: "L\xFCtfen teklifi inceleyip online onaylay\u0131n veya reddedin."
      },
      QUOTE_ACCEPTED: {
        title: "Teklif onayland\u0131",
        body: "Onay\u0131n\u0131z i\xE7in te\u015Fekk\xFCrler. Tarihi ve ekibi k\u0131sa s\xFCre i\xE7inde netle\u015Ftirece\u011Fiz."
      },
      QUOTE_REJECTED: {
        title: "Teklif reddedildi",
        body: "Teklifi reddettiniz. Revize bir teklif isterseniz bize ula\u015F\u0131n."
      },
      SCHEDULED: {
        title: "\u0130\u015F planland\u0131",
        body: "Tarih ve ekip netle\u015Fti. O g\xFCn sizi bilgilendirece\u011Fiz."
      },
      IN_PROGRESS: {
        title: "\u0130\u015F devam ediyor",
        body: "Ekibimiz varl\u0131\u011F\u0131n\u0131z \xFCzerinde \xE7al\u0131\u015F\u0131yor. \u0130lerlemeyi buradan takip edebilirsiniz."
      },
      COMPLETED: {
        title: "\u0130\u015F tamamland\u0131",
        body: "\u0130\u015F bitti. Sonu\xE7 foto\u011Fraflar\u0131 a\u015Fa\u011F\u0131da; fatura ard\u0131ndan gelecek."
      },
      INVOICED: {
        title: "Faturaland\u0131",
        body: "\u0130\u015F tamamland\u0131 ve faturaland\u0131. DuvaMarine\u2019i tercih etti\u011Finiz i\xE7in te\u015Fekk\xFCrler."
      },
      CANCELLED: {
        title: "Talep iptal edildi",
        body: "Bu talep iptal edildi."
      }
    },
    quote: "Teklif",
    validUntil: "{{date}} tarihine kadar ge\xE7erli",
    reviewQuote: "Teklifi incele ve onayla",
    openQuote: "Teklifi a\xE7",
    work: "\u0130\u015F emri",
    workStatus: "Durum",
    schedule: "Tarih",
    notScheduled: "Planlanacak",
    tasks: "Tamamlanan g\xF6revler",
    afterPhotos: "Sonu\xE7",
    details: "Talep detaylar\u0131",
    preferred: "Tercih edilen tarihler",
    flexible: "Esnek",
    items: "Talep edilen hizmetler",
    notes: "Notlar\u0131n\u0131z",
    payments: "\xD6demeler",
    invoices: "Faturalar",
    history: "Ge\xE7mi\u015F",
    cancel: {
      title: "Talebi iptal et",
      body: "Talep ve a\xE7\u0131k teklif geri \xE7ekilir. Diledi\u011Finiz zaman yeni talep g\xF6nderebilirsiniz.",
      reason: "Neden (iste\u011Fe ba\u011Fl\u0131)",
      submit: "Talebi iptal et",
      done: "Talep iptal edildi."
    },
    backToAccount: "Hesab\u0131ma d\xF6n",
    notFound: "Bu talep hesab\u0131n\u0131zda bulunamad\u0131."
  },
  quotePage: {
    title: "Teklif {{code}}",
    heroes: {
      DRAFT: {
        title: "Teklif haz\u0131rlan\u0131yor",
        body: "Bu teklif hen\xFCz haz\u0131rlan\u0131yor."
      },
      SENT: {
        title: "Teklifiniz",
        body: "Say\u0131n {{name}}, a\u015Fa\u011F\u0131daki teklifi inceleyip online onaylayabilirsiniz."
      },
      VIEWED: {
        title: "Teklifiniz",
        body: "Say\u0131n {{name}}, a\u015Fa\u011F\u0131daki teklifi inceleyip online onaylayabilirsiniz."
      },
      ACCEPTED: {
        title: "Teklif onayland\u0131",
        body: "Te\u015Fekk\xFCrler {{name}}. Onay\u0131n\u0131z kaydedildi; i\u015F planlanacak."
      },
      REJECTED: {
        title: "Teklif reddedildi",
        body: "Bu teklif reddedildi. Revize bir teklif isterseniz bize ula\u015F\u0131n."
      },
      EXPIRED: {
        title: "Teklifin s\xFCresi doldu",
        body: "Bu teklifin ge\xE7erlilik s\xFCresi sona erdi. G\xFCncel teklif i\xE7in bize ula\u015F\u0131n."
      },
      CANCELLED: {
        title: "Teklif geri \xE7ekildi",
        body: "Bu teklif geri \xE7ekildi."
      },
      SUPERSEDED: {
        title: "Teklif revize edildi",
        body: "Bu teklifin yeni bir s\xFCr\xFCm\xFC size e-postayla g\xF6nderildi."
      }
    },
    lines: "Kalemler",
    lineDiscount: "%{{percent}} indirim",
    vat: "KDV %{{percent}}",
    terms: "Notlar ve ko\u015Fullar",
    summary: "\xD6zet",
    subtotal: "Ara toplam",
    discount: "\u0130ndirim",
    net: "Net",
    total: "Toplam",
    validUntil: "{{date}} tarihine kadar ge\xE7erli",
    depositHint: "\u015Eimdi {{amount}}, kalan {{balance}} sonra",
    accept: {
      title: "Teklifi onayla",
      body: "{{amount}} tutar\u0131ndaki teklifi ve ko\u015Fullar\u0131n\u0131 onayl\u0131yorsunuz. \u0130\u015F, onaydan sonra planlan\u0131r.",
      submit: "Onayla",
      done: "Te\u015Fekk\xFCrler \u2014 teklif onayland\u0131."
    },
    reject: {
      title: "Teklifi reddet",
      body: "Dilerseniz daha uygun bir teklif g\xF6nderebilmemiz i\xE7in nedenini payla\u015F\u0131n.",
      reason: "Neden (iste\u011Fe ba\u011Fl\u0131)",
      submit: "Reddet",
      done: "Teklif reddedildi."
    },
    pdf: "PDF indir",
    notFound: {
      title: "Teklif bulunamad\u0131",
      body: "Ba\u011Flant\u0131 eksik olabilir. E-postadaki ba\u011Flant\u0131y\u0131 yeniden a\xE7\u0131n veya hesab\u0131n\u0131za giri\u015F yap\u0131n."
    }
  },
  myServices: {
    title: "Hizmet taleplerim",
    new: "Yeni talep",
    empty: "Hen\xFCz hizmet talebiniz yok."
  },
  myAssets: {
    title: "Yat, jet ve ara\xE7lar\u0131m",
    add: "Ekle",
    edit: "D\xFCzenle",
    remove: "Kald\u0131r",
    hint: "Kay\u0131tl\u0131 varl\u0131klar hizmet taleplerinde otomatik doldurulur.",
    type: "T\xFCr",
    empty: "Hen\xFCz kay\u0131tl\u0131 varl\u0131\u011F\u0131n\u0131z yok.",
    saved: "Kaydedildi.",
    removed: "Kald\u0131r\u0131ld\u0131.",
    confirmRemove: '"{{name}}" hesab\u0131n\u0131zdan kald\u0131r\u0131ls\u0131n m\u0131? Ge\xE7mi\u015F talepler korunur.',
    requests: "Talep: {{count}}"
  },
  content: {
    loadFailed: "\u0130\xE7erik y\xFCklenemedi. L\xFCtfen tekrar deneyin.",
    updated: "Son g\xFCncelleme: {{date}}",
    pageTypes: {
      STATIC: "DuvaMarine",
      LEGAL: "Yasal bilgilendirme",
      LANDING: "Kampanya"
    },
    blog: {
      eyebrow: "Rehber & haberler",
      title: "Blog",
      subtitle: "Rotalar, deneyimler ve l\xFCks seyahat ipu\xE7lar\u0131.",
      all: "T\xFCm\xFC",
      tagged: "#{{tag}} etiketli yaz\u0131lar.",
      clear: "Filtreyi kald\u0131r",
      empty: "Hen\xFCz yaz\u0131 yok.",
      back: "T\xFCm yaz\u0131lar",
      related: "\u0130lgili yaz\u0131lar"
    },
    faq: {
      eyebrow: "Yard\u0131m",
      title: "S\u0131k\xE7a sorulan sorular",
      subtitle: "Rezervasyon, \xF6deme, iptal ve hizmetlerimiz hakk\u0131nda merak edilenler.",
      empty: "Hen\xFCz soru eklenmedi.",
      general: "Genel",
      groups: {
        booking: "Rezervasyon",
        payment: "\xD6deme",
        cancellation: "\u0130ptal ve iade",
        privacy: "Gizlilik ve KVKK",
        yacht: "Yat kiralama",
        jet: "\xD6zel jet",
        car: "L\xFCks ara\xE7",
        transfer: "VIP transfer",
        services: "Sahip hizmetleri"
      },
      more: "Arad\u0131\u011F\u0131n\u0131z cevab\u0131 bulamad\u0131n\u0131z m\u0131? Ekibimiz yard\u0131mc\u0131 olmaktan memnuniyet duyar.",
      contact: "Bize ula\u015F\u0131n"
    }
  },
  cookies: {
    title: "\xC7erez tercihleriniz",
    body: "Sitenin \xE7al\u0131\u015Fmas\u0131 i\xE7in zorunlu \xE7erezler kullan\u0131yoruz. Onay verirseniz deneyimi geli\u015Ftirmek i\xE7in analitik, size uygun kampanyalar i\xE7in pazarlama \xE7erezleri de kullan\u0131r\u0131z.",
    policy: "\xC7erez Politikas\u0131",
    necessary: "Zorunlu \xE7erezler",
    necessaryHint: "Oturum, sepet ve g\xFCvenlik i\xE7in gereklidir; kapat\u0131lamaz.",
    analytics: "Analitik \xE7erezler",
    analyticsHint: "Ziyaret istatistikleri (Google Analytics).",
    marketing: "Pazarlama \xE7erezleri",
    marketingHint: "Reklam \xF6l\xE7\xFCm\xFC ve ki\u015Fiselle\u015Ftirme (Meta Pixel).",
    save: "Se\xE7imi kaydet",
    customize: "Tercihler",
    reject: "Yaln\u0131zca zorunlu",
    accept: "T\xFCm\xFCn\xFC kabul et",
    close: "Kapat"
  }
};

// src/core.ts
var LOCALES = ["tr", "en", "ar", "ru"];
var DEFAULT_APP_LOCALE = "tr";
var NAMESPACES = [
  "common",
  "auth",
  "validation",
  "errors",
  "web",
  "admin",
  "email",
  "documents"
];
var DEFAULT_NAMESPACE = "common";
var LOCALE_STORAGE_KEY = "dm.locale";
function isAppLocale(value) {
  return typeof value === "string" && LOCALES.includes(value);
}
function getDirection(locale) {
  return locale.split("-")[0] === "ar" ? "rtl" : "ltr";
}
function toIntlLocale(locale) {
  const map = { tr: "tr-TR", en: "en-GB", ar: "ar", ru: "ru-RU" };
  return map[locale];
}
function toValidationKey(message) {
  return message.startsWith("validation.") ? message.slice("validation.".length) : null;
}
function interpolate(template, values) {
  return template.replace(
    /\{\{\s*(\w+)\s*\}\}/g,
    (match, key) => key in values ? String(values[key]) : match
  );
}

export {
  auth,
  common,
  errors,
  validation,
  web,
  LOCALES,
  DEFAULT_APP_LOCALE,
  NAMESPACES,
  DEFAULT_NAMESPACE,
  LOCALE_STORAGE_KEY,
  isAppLocale,
  getDirection,
  toIntlLocale,
  toValidationKey,
  interpolate
};
//# sourceMappingURL=chunk-KE26HA2Q.js.map